export default {
  services_number_title: "Number of services to choose from",
  additional_information_after_booking_title:
    "Additional information in booking emails",
  additional_information_after_booking_subtitle:
    "We add it to the emails about a new, changed or upcoming booking.",
  additional_information_after_booking_dummy_text:
    "This is a sample text that will be replaced with additional information after booking, if such information has been provided in the service settings.",
  plugins_storage_100gb_cd_base_pro_name: "File storage 100 GB",
  plugins_storage_500gb_cd_base_pro_name: "File storage 500 GB",
  plugins_storage_100gb_cd_base_pro_description:
    "More file space. Gain 100 GB of additional space for file sharing with clients and receiving attachments via booking forms. An ideal solution to streamline communication and improve customer service.",
  plugins_storage_500gb_cd_base_pro_description:
    "Maximum space for your files. Use 500 GB of storage to exchange files with clients and receive attachments via booking forms without limitations. Essential for rapidly growing businesses that value professionalism and convenience.",
  bookings_this_month: "Bookings this month",
  bookings_all_processed: "All bookings",
  simple_store_product_transactions_this_month: "Products sold this month",
  files_storage_usage: "Used file storage",
  files_storage_usage_from_available_prefix: "of available",
  not_available_in_standard_plan: "Feature not available in the Standard plan",
  ai_tokens_usage: "AI tokens used",
  ai_tokens_usage_from_available_prefix: "of available",
  ai_tokens_resets_at: "Resets",
  cancel_reason_dropdown_label: "Reason for canceling your subscription",
  cancel_subscription_category_1_title: "Technical issues",
  cancel_subscription_category_1_reason_1_title: "Frequent crashes or downtime",
  cancel_subscription_category_1_reason_2_title: "Slow system performance",
  cancel_subscription_category_1_reason_3_title: "Hard-to-use interface",
  cancel_subscription_category_1_reason_4_title:
    "Problems with integrations (e.g., payment system, external calendars)",
  cancel_subscription_category_1_reason_5_title:
    "Security concerns (e.g., data breaches)",
  cancel_subscription_category_1_reason_6_title:
    "Problems with the employee’s mobile application (e.g., crashes, bugs)",
  cancel_subscription_category_2_title: "Personal or business changes",
  cancel_subscription_category_2_reason_1_title:
    "Business model change (e.g., reduced need for bookings)",
  cancel_subscription_category_2_reason_2_title:
    "Budget constraints or financial difficulties",
  cancel_subscription_category_2_reason_3_title:
    "Too much workload to manage the system",
  cancel_subscription_category_2_reason_4_title:
    "Closing or downsizing my business",
  cancel_subscription_category_2_reason_5_title:
    "Not enough time to manage bookings",
  cancel_subscription_category_3_title: "Pricing and competition",
  cancel_subscription_category_3_reason_1_title:
    "Cheaper alternatives available",
  cancel_subscription_category_3_reason_2_title:
    "Price increase or billing model change",
  cancel_subscription_category_4_title: "User experience issues",
  cancel_subscription_category_4_reason_1_title:
    "Difficult to navigate the system",
  cancel_subscription_category_4_reason_2_title: "Missing essential features",
  cancel_subscription_category_4_reason_3_title:
    "Too complex for my team or business",
  cancel_subscription_category_4_reason_4_title:
    "Slow or unhelpful customer support",
  cancel_subscription_category_4_reason_5_title:
    "Limited customization options",
  cancel_subscription_category_4_reason_6_title:
    "Complicated setup or onboarding process",
  cancel_subscription_category_5_title: "External and market factors",
  cancel_subscription_category_5_reason_1_title:
    "Market trends have shifted (e.g., moving to social media bookings)",
  cancel_subscription_category_5_reason_2_title:
    "Economic downturn or financial instability",
  cancel_subscription_category_5_reason_3_title: "Changes in legal regulations",
  cancel_subscription_category_6_title: "Other",
  cancel_subscription_category_6_reason_1_title: "A reason not listed here",
  cancel_subscription_category_6_reason_2_title: "I prefer not to say",
  cancel_plan_and_delete_data: "Cancel and delete my data",
  cancel_plan_do_nothing: "Do nothing",
  cancel_plan_and_keep_data_confirmation_label:
    "Are you sure you want to cancel your subscription but keep your data?",
  cancel_plan_and_keep_data_confirmation_info:
    "The subscription will be canceled at the end of the already paid billing period. The data will be securely stored on our servers and can be restored at any time upon reactivating the subscription.",
  scheduled_cancel_keeps_data_info:
    "Your plan will be canceled, but your data will remain stored",
  no_just_checking_title: "No, I’m just checking",
  payment_deadline_before_start_variable:
    "Payment deadline before the start of each recurring booking",
  send_payment_reminder_before_start_variable:
    "Time of payment reminder notification before the booking",
  variable_service_reschedule_deadline_before_start:
    "Reschedule deadline before booking start",
  variable_service_cancel_deadline_before_start:
    "Cancel deadline before booking start",
  variable_customer_private_notes: "Customer's private notes",
  booking_awaiting_payment_full_description:
    "Complete information about required payment",
  booking_awaiting_payment_full_description_example:
    "Your booking will be cancelled if no payment is made within 30 min. Click below to proceed to your booking and make the payment.",
  recurring_meeting_in_the_past_warning:
    'You cannot create a recurring meeting with start dates in the past. Choose a start date in the future or uncheck the "This event recurs" option.',
  booking_overlaps_dialog_title: "Calendar conflict detected",
  booking_overlaps_dialog_message:
    "While verifying availability, we detected that the selected time conflicts with existing bookings or blackout dates. Conflict details:",
  booking_overlaps_count: "Number of conflicting bookings",
  unavailable_slot_overlaps_count: "Number of conflicting blackout dates",
  booking_overlaps_dialog_question: "Do you want to continue anyway?",
  selected_date: "Selected date",
  single_booking: "Single booking",
  external_api_service_not_enabled_error:
    "Unfortunately, the API feature is not available on this account.",
  integration_auth_code_expired_error:
    'The connection could not be completed because the authorization expired. Click "Connect" again and finish signing in without long pauses.',
  outlook_mailbox_not_available_error:
    "We could not connect this Microsoft account's calendar. The reason may be a mailbox running on a company server instead of Microsoft 365, an account without an active mailbox, or a deleted one. Check it with your Microsoft 365 administrator.",
  service_not_available_at_selected_time:
    "The service is not available at the selected time.",
  service_not_available_pool_full: "The service isn't available at this time: there's no free position in the pool \"@{pool}\" (taken: @{used} of @{capacity}).",
  service_not_available_pool_rule: "The service isn't available at this time: the free positions of the pool \"@{pool}\" are meant for other bookings.",
  service_not_available_resource_taken: "The service isn't available at this time: the resource \"@{resource}\" is taken by another booking.",
  offline_mode: "You are offline",
  offline_description:
    "The application requires an internet connection to function.",
  retry: "Retry",
  checking_connection: "Checking connection...",
  waiting_for_connection: "Waiting for connection",
  "2fa_verify_title": "Two-factor authentication",
  "2fa_verify_description":
    "Enter your 6-digit code from your authenticator app or use a recovery code:",
  "2fa_recovery_code_label": "Recovery code",
  "2fa_use_recovery_code": "Use recovery code instead",
  "2fa_use_app_code": "Use app code",
  "2fa_verify_incorrect_error": "The 2FA code is incorrect. Please try again.",
  "2fa_session_expired_error":
    "Your 2FA session has expired. Please log in again.",
  "2fa_verification_cancelled":
    "Two-factor authentication was cancelled. Please try again.",
  enable_2fa: "Enable 2FA",
  enable_2fa_title: "Turn on 2-step verification",
  disable_2fa: "Disable 2FA",
  disable_2fa_title: "Turn off 2-step verification",
  "2fa_manual_setup": "Can't scan? Enter this code manually:",
  "2fa_recovery_codes_title": "Recovery codes",
  "2fa_download_codes": "Download codes",
  "2fa_disable_description":
    "You're about to turn off 2-step verification. This will make your account less secure.",
  "2fa_disable_warning":
    "Disabling 2-step verification will reduce your account security.",
  "2fa_verify_to_disable": "Verify your identity",
  "2fa_verify_to_disable_description":
    "Enter a code from your authenticator app or use a recovery code to disable 2-step verification.",
  warning: "Warning",
  current_password: "Current password",
  incorrect_password: "Incorrect password. Please try again.",
  "2fa_setup_failed": "Failed to setup 2FA",
  "2fa_activation_failed": "Failed to activate 2FA",
  "2fa_verification_code": "Verification code",
  "2fa_disabled_success": "2FA has been successfully disabled",
  "2fa_disable_failed": "Failed to disable 2FA",
  "2fa_step_1_password_title": "Enter your password",
  "2fa_step_1_scan_title": "Scan QR code",
  "2fa_step_2_verify_title": "Verify setup",
  "2fa_authenticator_apps_required": "Authenticator app required",
  "2fa_setup_secure_subtitle":
    "Choose and install a secure 2FA app to protect your account",
  "2fa_apps_installation_note":
    "Install one of these apps on your phone before continuing with the setup.",
  "2fa_scan_with_app": "Scan this QR code with your authenticator app",
  "2fa_enter_code_from_app":
    "Enter the 6-digit code from your authenticator app",
  "2fa_recovery_codes_warning":
    "Store these codes in a secure location. Each code can only be used once.",
  "2fa_enter_password_to_continue":
    "Enter your current password to generate your unique QR code",
  "2fa_enter_password_to_disable":
    "Enter your current password to confirm disabling 2FA",
  "2fa_disable_verification_description":
    "Enter your current password and a code from your authenticator app or use a recovery code to disable 2-step verification.",
  "2fa_recovery_codes_description":
    "These backup codes allow you to access your account if you lose your authenticator app. Each code can only be used once, so keep them in a safe place.",
  security_settings: "Security settings",
  security_settings_description:
    "Manage your account security settings and authentication methods.",
  "2fa_security_title": "2-step verification",
  "2fa_security_description":
    "Add an extra layer of security to your account with 2-step verification.",
  reset_password_description:
    "Send a password reset link to your email address.",
  "2fa_enabled_success": "2FA has been successfully enabled",
  linkedin: "LinkedIn",
  profile_company_social_media_linkedin_label_input:
    "Link to a LinkedIn profile",
  logs_diff_linkedin: "Link to a LinkedIn profile",
  tiktok: "TikTok",
  profile_company_social_media_tiktok_label_input: "Link to a TikTok profile",
  logs_diff_tiktok: "Link to a TikTok profile",
  wb_linkedin: "LinkedIn URL",
  wb_tiktok: "TikTok URL",
  plugins_calendesk_chat_cd_base_standard_name: "Calendesk Chat",
  plugins_calendesk_chat_cd_base_standard_description:
    "Enhance your customer communication with Calendesk Chat. Provide real-time support, answer questions, and engage with your clients directly from your booking page. Perfect for businesses that want to build stronger relationships with customers.",
  plugins_calendesk_chat_cd_base_pro_name: "Calendesk Chat",
  plugins_calendesk_chat_cd_base_pro_description:
    "Enhance your customer communication with Calendesk Chat. Provide real-time support, answer questions, and engage with your clients directly from your booking page. Perfect for businesses that want to build stronger relationships with customers.",
  number_of_agents: "Number of agents",
  agents_plural: "agents",
  integrations_category_customer_support: "Customer support",
  chatwoot_title: "Calendesk Chat",
  chatwoot_description:
    "Manage your live chat support. Access dashboard, configure agents, and view conversations.",
  chatwoot_package_not_active:
    "Calendesk Chat package is not active. Please activate it in your subscription settings.",
  chatwoot_setup_title: "Set up your chat support",
  chatwoot_setup_info:
    'Calendesk Chat is a separate application available at <a href="https://chat.calendesk.com" target="_blank">chat.calendesk.com</a> where you will manage conversations with customers.',
  chatwoot_setup_sso_warning:
    "All Calendesk administrators with access to integrations will be able to log in to the chat dashboard.",
  chatwoot_setup_next_steps_title: "After setup:",
  chatwoot_setup_next_step_1:
    'A chat account will be created at <a href="https://chat.calendesk.com" target="_blank">chat.calendesk.com</a>',
  chatwoot_setup_next_step_2:
    "Administrators will be able to log in to the chat dashboard with one click from the Calendesk menu",
  chatwoot_setup_next_step_3:
    "You can add the chat widget to your booking page - the embed code is available in the chat dashboard",
  chatwoot_company_section_title: "Company details",
  chatwoot_admin_section_title: "Chat administrator",
  chatwoot_business_name: "Business name",
  chatwoot_business_name_hint:
    "Visible to customers in the chat widget and notifications",
  chatwoot_admin_name: "Name",
  chatwoot_admin_email: "Email",
  chatwoot_support_email: "Customer support email",
  chatwoot_support_email_placeholder: "e.g. support@yourcompany.com",
  chatwoot_support_email_hint:
    "Customers will see this address as the sender of email replies from your team",
  chatwoot_start_integration: "Set up",
  chatwoot_integration_active: "Calendesk Chat is active and ready to use.",
  chatwoot_dashboard_info:
    'Manage your conversations, agents, and settings in the chat dashboard at <a href="https://chat.calendesk.com" target="_blank">chat.calendesk.com</a>.',
  chatwoot_sso_warning:
    "All Calendesk administrators with access to integrations can log in to the chat dashboard with one click.",
  chatwoot_open_dashboard: "Open dashboard",
  chatwoot_agent_limit: "Agent slots",
  chatwoot_buy_more_agents: "Need more agents? Upgrade your package",
  chatwoot_integration_success: "Calendesk Chat has been successfully set up!",
  chatwoot_integration_error:
    "Failed to set up Calendesk Chat. Please try again or contact support.",
  chatwoot_sso_error:
    "Failed to open chat dashboard. Please try again or contact support.",
  chatwoot_suspend_button: "Suspend",
  chatwoot_suspend_title: "Suspend Calendesk Chat",
  chatwoot_suspend_warning:
    "Suspending will deactivate the chat widget on the website for end customers, <strong>but does not affect the package activity or related charges</strong>.<br><br>To cancel the package, go to <strong>Billing → Subscription</strong> and select <strong>Disable</strong>.",
  chatwoot_suspend_confirm: "Suspend",
  chatwoot_suspend_success: "Calendesk Chat has been suspended.",
  chatwoot_suspend_error:
    "Failed to suspend Calendesk Chat. Please try again or contact support.",
  chatwoot_suspended_info:
    "Your Calendesk Chat account is currently suspended.",
  chatwoot_suspended_data_preserved:
    "All your conversations and settings are preserved and will be restored when you reactivate.",
  chatwoot_reactivate_button: "Reactivate",
  chatwoot_reactivation_success: "Calendesk Chat has been reactivated!",
  chatwoot_reactivation_error:
    "Failed to reactivate Calendesk Chat. Please try again or contact support.",
  chatwoot_suspended_tooltip: "Suspended - click to reactivate",
  chatwoot_agent_limit_exceeded:
    "You have @{current} agents, but your package allows only @{limit}.",
  chatwoot_agent_limit_contact_support:
    "To reactivate Calendesk Chat, please contact our support team. We will help you adjust the number of agents to match your package limit.",
  contact_support: "Contact support",
  chatwoot_min_agents_info:
    "Minimum @{count} agents required based on your current Calendesk Chat configuration.",
  chatwoot_close_confirm_title: "Close form?",
  chatwoot_close_confirm_warning:
    "Your entered data has not been saved and will be lost.",
  chatwoot_close_confirm_yes: "Close",
  chatwoot_close_confirm_no: "Back to form",
  dialog_close_confirm_title: "Close?",
  dialog_close_confirm_warning: "Unsaved changes will be lost.",
  dialog_close_confirm_yes: "Close",
  dialog_close_confirm_no: "Cancel",
  reports: "Reports",
  reports_granularity: "Group by",
  reports_revenue: "Revenue & Payments",
  reports_bookings: "Bookings",
  reports_team: "My team",
  reports_customers: "Customers & Commerce",
  reports_clients: "Clients",
  reports_subscriptions: "Subscriptions",
  reports_products: "Products",
  reports_tab_revenue: "Revenue",
  date_range: "Date range",
  vs_previous_period: "vs previous period",
  reports_revenue_timeline: "Revenue timeline",
  reports_top_services: "Top services",
  reports_top_products: "Top products",
  reports_payment_providers: "Payment methods",
  reports_payment_methods_count: "Transactions by payment method",
  reports_payment_methods_value: "Revenue by payment method",
  reports_payment_timeline: "Payment timeline",
  reports_bookings_timeline: "Bookings timeline",
  reports_by_service: "By service",
  reports_by_employee: "By employee",
  reports_by_delivery_type: "By delivery type",
  reports_cancellation_reasons: "Cancellation reasons",
  reports_by_day: "By day of week",
  reports_by_hour: "By hour",
  reports_heatmap: "Booking heatmap",
  reports_employee_performance: "Team performance",
  reports_service_ranking: "Service ranking",
  reports_by_category: "By category",
  reports_locations: "Locations",
  reports_customer_segments: "Client engagement",
  reports_top_customers: "Top clients",
  reports_product_revenue_timeline: "Product revenue timeline",
  reports_booking_revenue_timeline: "Booking revenue over time",
  reports_top_subscriptions: "Top subscriptions",
  reports_subscription_timeline: "New subscriptions over time",
  reports_subscription_revenue_timeline: "Subscription revenue over time",
  reports_revenue_forecast: "Revenue forecast",
  reports_bookings_forecast: "Bookings forecast",
  reports_section_key_metrics: "Key metrics",
  reports_section_key_metrics_tooltip:
    "<b>Key metrics</b><br><br>Your main business indicators in the selected period. Arrows show changes compared to the previous period of the same length.",
  reports_section_trends: "Trends",
  reports_section_trends_tooltip:
    "<b>Trends</b><br><br>How your revenue and bookings changed over time in the selected period.",
  reports_section_revenue: "Revenue",
  reports_section_revenue_tooltip:
    "<b>Revenue</b><br><br>Total income from all sources in the selected period. Only <b>completed payments</b> are counted.<br><br>Includes:<br>• <b>Revenue breakdown</b> — from bookings, subscriptions, and products<br>• <b>Avg booking value</b> and <b>booking payment rate</b><br>• <b>Revenue timeline</b> — how income changed over time<br>• <b>Top services, subscriptions, and products</b> — ranked by revenue<br>• <b>Payment methods</b> — transaction count and revenue per method",
  reports_section_bookings: "Bookings",
  reports_section_bookings_tooltip:
    "<b>Bookings</b><br><br>Booking statuses, volume over time, and breakdown by service and team member in the selected period.<br><br>Includes:<br>• <b>Status breakdown</b> — approved, done, cancelled counts<br>• <b>Bookings timeline</b> — volume changes over time<br>• <b>Booking revenue</b> — how booking revenue changed over time<br>• <b>By service and team member</b> — most booked services and busiest staff",
  reports_section_patterns: "Booking patterns",
  reports_section_patterns_tooltip:
    "<b>Booking patterns</b><br><br>When your clients prefer to book. Use this to optimize your schedule.<br><br>Includes:<br>• <b>Peak hours heatmap</b> — busiest days and hours<br>• <b>Busiest day</b> — which day of the week gets the most bookings<br>• <b>By hour</b> — booking distribution across the day",
  reports_section_employees: "My team",
  reports_section_employees_tooltip:
    "<b>My team</b><br><br>How each team member performed in the selected period.<br><br>Includes:<br>• <b>Bookings completed</b> — number of done bookings per person<br>• <b>Revenue generated</b> — income from their bookings<br>• <b>Schedule fill rate</b> — how much of their available time was booked",
  reports_section_services: "Services",
  reports_section_services_tooltip:
    "<b>Services</b><br><br>Most popular services and their revenue in the selected period.<br><br>Includes:<br>• <b>Bookings per service</b> — number of approved and done bookings<br>• <b>Revenue per service</b> — income generated",
  reports_section_locations: "Locations",
  reports_section_locations_tooltip:
    "<b>Locations</b><br><br>Performance breakdown by business location and delivery type in the selected period.",
  reports_section_customers: "Customers",
  reports_section_customers_tooltip:
    "<b>Customers</b><br><br>Who books most often, who spends the most, and how engaged your clients are in the selected period.<br><br>Includes:<br>• <b>New clients</b> — registered in the selected period<br>• <b>Active clients</b> — had at least one booking<br>• <b>Engagement chart</b> — first-timers vs returning vs loyal regulars<br>• <b>Top customers</b> — highest spenders in the selected period",
  reports_section_customer_overview: "Clients",
  reports_section_customer_overview_tooltip:
    "<b>Clients</b><br><br>These values cover your entire history and don't change with the date filter.",
  reports_section_customer_activity: "Activity in period",
  reports_section_customer_activity_tooltip:
    "<b>Activity in period</b><br><br>How your clients engaged in the selected period — bookings, retention, and preferences.",
  reports_section_products: "Products",
  reports_section_products_tooltip:
    "<b>Products</b><br><br>Product sales, revenue over time, and best sellers in the selected period.<br><br>Includes:<br>• <b>Total product revenue</b> in the selected period<br>• <b>Revenue timeline</b> — how product sales changed over time<br>• <b>Top products</b> — best sellers ranked by revenue",
  reports_section_subscriptions: "Subscriptions",
  reports_section_subscriptions_tooltip:
    "<b>Subscriptions</b><br><br>Revenue, renewals, and usage of your subscription plans in the selected period.<br><br>Includes:<br>• <b>Active subscriptions</b> — how many clients have an active plan right now<br>• <b>Revenue</b> — how much you earned from subscriptions in the selected period<br>• <b>Renewal rate</b> — how many subscribers paid more than once (higher = clients keep coming back)<br>• <b>New subscriptions</b> — how many new subscriptions were started per period<br>• <b>Subscription revenue</b> — how subscription revenue changed over time<br>• <b>Top subscriptions</b> — which plans bring in the most money<br>• <b>Usage</b> — are subscribers actually using their included bookings?",
  reports_section_payments: "Payments",
  reports_section_payments_tooltip:
    "<b>Payments</b><br><br>Transaction data and payment method breakdown in the selected period.<br><br>Includes:<br>• <b>Total transactions</b> — number of completed payments<br>• <b>Booking payment rate</b> — percentage of paid bookings<br>• <b>By payment method</b> — transaction count and revenue per method",
  reports_section_booking_status: "Booking status",
  reports_section_cancellation_reasons: "Cancellation reasons",
  reports_section_peak_hours: "Peak hours",
  reports_section_peak_hours_tooltip:
    "<b>How to read this chart:</b><br><br><b>Rows</b> = days of the week<br><b>Columns</b> = hours of the day (00:00–23:00)<br><br>Each cell shows the <b>total number</b> of approved and done bookings scheduled at that day and hour across the <b>entire selected period</b>.<br><br><b>Example:</b> If you selected 3 months, the cell at Monday 10:00 shows how many bookings fell on any Monday at 10:00 during those 3 months combined.<br><br>🟦 Darker color = more bookings",
  reports_section_busiest_day: "Busiest day of week",
  stats_monday: "Monday",
  stats_tuesday: "Tuesday",
  stats_wednesday: "Wednesday",
  stats_thursday: "Thursday",
  stats_friday: "Friday",
  stats_saturday: "Saturday",
  stats_sunday: "Sunday",
  stats_mon: "Mon",
  stats_tue: "Tue",
  stats_wed: "Wed",
  stats_thu: "Thu",
  stats_fri: "Fri",
  stats_sat: "Sat",
  stats_sun: "Sun",
  reports_section_delivery_type: "By delivery type",
  reports_section_peak_times: "Peak times",
  reports_bookings_by_hour: "Bookings by hour",
  reports_bookings_by_service: "Top services",
  reports_bookings_by_employee: "Top team members",
  reports_booking_lead_time: "Booking lead time",
  reports_bookings_by_location: "Bookings by location",
  reports_employee_performance_note:
    'Schedule fill rate shows "--" if no working hours are set for this team member.',
  reports_customer_segments_chart: "Client segments",
  reports_customer_segments_note:
    "Breaks down active clients into three groups based on booking history. All three sum to active clients.",
  reports_services_by_category: "Bookings by category",
  reports_service_ranking_note:
    "Sorted by number of bookings. Click any column to re-sort.",
  reports_mrr_trend: "New subscriptions",
  reports_subscription_usage: "Subscription usage",
  reports_subscription_usage_tooltip:
    "Are your subscribers actually using the bookings included in their plans?<br><br>• <b>Booking limit usage</b> — if a plan includes 10 bookings and a client used 3, that's 30%. This is the average across all subscribers.<br>• <b>Unused bookings</b> — the total number of included bookings that nobody used. A high number means subscribers are leaving value on the table.",
  stats_revenue: "Revenue",
  stats_bookings: "Bookings",
  stats_subscriptions: "Subscriptions",
  stats_products: "Products",
  stats_new_customers: "New customers",
  stats_cancellation_rate: "Cancellation rate",
  stats_avg_booking_value: "Avg booking value",
  stats_total_revenue: "Total revenue",
  stats_from_bookings: "Bookings",
  stats_from_products: "Products",
  stats_from_subscriptions: "Subscriptions",
  stats_active_employees: "Active employees",
  stats_team_revenue: "Team revenue",
  stats_schedule_fill_rate: "Schedule fill rate",
  stats_total_booked_hours: "Total booked hours",
  stats_total_bookings: "Total bookings",
  stats_approved: "Approved",
  stats_done: "Done",
  stats_cancelled: "Cancelled",
  stats_payment: "Awaiting payment",
  stats_status: "Status",
  stats_service: "Service",
  stats_employee: "Employee",
  stats_delivery_type: "Delivery type",
  stats_share: "Share",
  stats_reason: "Reason",
  stats_cancellations: "Cancellations",
  stats_category: "Category",
  stats_location: "Location",
  stats_type: "Type",
  stats_provider: "Method",
  stats_transactions: "Transactions",
  stats_value: "Total",
  stats_product: "Product",
  stats_quantity: "Quantity",
  stats_subscription: "Subscription",
  stats_customer: "Customer",
  stats_email: "Email",
  stats_customers_served: "Customers served",
  stats_utilization: "Occupancy",
  stats_available_hours: "Available hours",
  stats_booked_hours: "Booked hours",
  stats_unique_customers: "Unique customers",
  stats_total_customers: "Total customers",
  stats_active_customers: "Active customers",
  stats_returning_customers: "Returning customers",
  stats_retention_rate: "Retention rate",
  stats_customer_ltv: "Lifetime value",
  stats_avg_days_between_visits: "Avg days between bookings",
  stats_preferred_delivery: "Preferred location",
  stats_preferred_payment: "Preferred payment",
  stats_total_spent: "Total spent",
  stats_total_sold: "Total sold",
  stats_product_revenue: "Product revenue",
  stats_active_subscriptions: "Active subscriptions",
  stats_subscription_revenue: "Subscription revenue",
  stats_renewal_rate: "Renewal rate",
  stats_active_users: "Active users",
  stats_avg_utilization: "Booking limit usage",
  stats_booking_limit_usage: "Booking limit usage",
  stats_unused_booking_slots: "Unused bookings",
  stats_unused_bookings: "Unused bookings",
  stats_total_transactions: "Total transactions",
  stats_total_value: "Total value",
  stats_booking_payment_rate: "Booking payment rate",
  stats_method: "Method",
  stats_day: "Day",
  stats_hour: "Hour",
  stats_busiest_day: "Busiest day",
  stats_busiest_hour: "Busiest hour",
  stats_average_lead_time: "Avg. days in advance",
  stats_median_lead_time: "Median days in advance",
  stats_month: "Month",
  stats_projected: "Projected",
  stats_low_estimate: "Low estimate",
  stats_high_estimate: "High estimate",
  stats_period: "Period",
  stats_count: "Count",
  stats_bookings_count: "Bookings",
  stats_name: "Name",
  stats_cancellation_rate_tooltip:
    "How often bookings get cancelled.<br><br><b>Formula:</b> cancelled ÷ (approved + done + cancelled)<br><b>Example:</b> 10 bookings, 2 cancelled = <b>20%</b>",
  stats_customer_ltv_tooltip:
    "How much a client has spent with you in total, across their entire history — not just the selected period.",
  stats_utilization_tooltip:
    "Average occupancy across your team. For each employee: booked hours ÷ available hours.<br><br><b>Available hours</b> come from the employee's <b>Availability schedule</b>. Days off and date overrides are taken into account.<br><br>Example: an employee works Mon–Fri, 9:00–17:00 (40h/week). If 30 hours are booked, occupancy is 75%.",
  stats_booking_payment_rate_tooltip:
    "Percentage of bookings that were paid, out of all bookings scheduled in the selected period.<br><br>Counted by service date — a booking created today for May shows up in the May report.",
  stats_renewal_rate_tooltip:
    "How many subscribers continued their plan after the first payment — a sign of client satisfaction.",
  stats_unused_booking_slots_tooltip:
    "The total number of bookings that subscribers could have made (based on their plan limits) but didn't.<br><br><b>Example:</b> 3 subscribers each have a plan with 10 bookings/month. One used 7, one used 3, one used 0. That's 3 + 7 + 10 = <b>20 unused bookings</b>.<br><br>A high number might mean your limits are too generous or subscribers need a reminder to book.",
  stats_active_subscriptions_tooltip:
    "New subscription plans that started in the selected period. This is <b>not</b> the total number of all active subscribers.",
  stats_avg_utilization_tooltip:
    "Some subscription plans include a set number of bookings (e.g. \"10 bookings per month\"). This shows what percentage of those included bookings your subscribers actually used.<br><br><b>Example:</b> A client buys a plan with 10 bookings/month but only books 3 times → that's 30% usage.<br><br>A low percentage means subscribers aren't fully using what they paid for. Only counts approved and done bookings.",
  stats_new_customers_tooltip:
    "New clients who registered in the selected period. Based on account creation date.",
  stats_total_revenue_tooltip:
    "Total income in the selected period from:<br>• bookings<br>• subscriptions<br>• product sales<br><br>Only <b>completed payments</b> are counted, based on the payment date.",
  stats_from_bookings_tooltip:
    "Revenue from booking payments in the selected period. Only <b>completed payments</b> are counted.",
  stats_from_products_tooltip:
    "Revenue from one-time product purchases in the selected period.",
  stats_from_subscriptions_tooltip:
    "Revenue from subscription plan payments in the selected period.",
  stats_total_bookings_tooltip:
    "Total <b>approved</b> and <b>done</b> bookings in the selected period. <b>Cancelled</b> and <b>awaiting payment</b> bookings are not counted.",
  stats_approved_tooltip:
    "Number of <b>approved</b> bookings in the selected period.",
  stats_done_tooltip: "Number of <b>done</b> bookings in the selected period.",
  stats_cancelled_tooltip:
    "Bookings that were <b>cancelled</b> in the selected period — by either the client or you.",
  stats_active_employees_tooltip:
    "Team members who had at least one approved or done booking in the selected period.",
  stats_team_revenue_tooltip:
    "Total booking revenue across all team members in the selected period. Only completed payments are counted.",
  stats_schedule_fill_rate_tooltip:
    'How much of your team\'s available time is filled with bookings.<br><br><b>How it works:</b><br>1. For each team member, we count every day in the selected period<br>2. For each day, we check their schedule — specific date overrides (days off, special hours) take priority over the regular weekly schedule<br>3. We add up all their booked hours (approved and done bookings)<br>4. Fill rate = booked hours ÷ available hours<br>5. We average this across all team members<br><br><b>Example:</b> Anna has 40h available, 20h booked → 50%. Mark has 40h available, 30h booked → 75%. Average = <b>62.5%</b><br><br>Team members without a schedule are skipped. Shows "--" if no one has a schedule set.',
  stats_total_booked_hours_tooltip:
    "Total hours spent on bookings across all team members in the selected period.",
  stats_customers_served_tooltip:
    "Number of different clients this team member worked with in the selected period.",
  stats_available_hours_tooltip:
    'How many hours this team member could work in the selected period, based on their schedule.<br><br><b>How it works:</b> We check every day in the selected period. For each day, we look at the schedule — if there\'s a specific date override (e.g. a day off), we use that. Otherwise, we use the regular weekly schedule for that weekday.<br><br><b>Example:</b> Mon–Fri 9:00–17:00. Period = Mon to Sun → 5 working days × 8h = <b>40h</b>. If Wednesday is marked as a day off, it becomes 4 × 8h = <b>32h</b>.<br><br>Shows "--" if no schedule is set.',
  stats_booked_hours_tooltip:
    "Working hours that were actually filled with bookings in the selected period.",
  stats_total_tooltip:
    "Total number of clients registered with you — across all time, not just the selected period.",
  stats_new_tooltip:
    "Clients who booked for the first time in the selected period — they had no bookings before.",
  stats_active_tooltip:
    "Clients who had at least one <b>approved</b> or <b>done</b> booking in the selected period.",
  stats_returning_tooltip:
    "Clients who had a booking before the selected period and came back again during it.",
  stats_ltv_tooltip:
    "Average total amount spent by a client since they first joined — across their entire history, not just the selected period.",
  stats_preferred_delivery_type_tooltip:
    "The most common location type your clients book — for example, Google Meet, address, phone, or Microsoft Teams.",
  stats_total_customers_tooltip:
    "Total number of registered clients — across all time, not just the selected period.",
  stats_preferred_payment_method_tooltip:
    "The payment method your clients use most often when paying for bookings.",
  stats_active_customers_tooltip:
    "Clients who had at least one booking in the selected period.",
  stats_returning_customers_tooltip:
    "Clients who had bookings before the selected period and came back during it. With <b>All time</b> selected, this will be 0.",
  stats_retention_rate_tooltip:
    "What percentage of active clients had booked with you before.<br><br><b>Formula:</b> returning ÷ active × 100<br><b>Example:</b> 10 active, 6 returning = <b>60%</b>",
  stats_avg_days_between_visits_tooltip:
    "On average, how many days pass between bookings for clients who come back more than once.",
  stats_total_sold_tooltip: "Number of products sold in the selected period.",
  stats_product_revenue_tooltip:
    "Total revenue from product sales in the selected period.",
  stats_subscription_revenue_tooltip:
    "Total revenue from subscription plan payments in the selected period.",
  stats_active_users_tooltip:
    "Subscribers who made at least one booking using their subscription plan in the selected period.",
  stats_total_value_tooltip:
    "Sum of all <b>completed</b> payment transactions (bookings, products, and subscriptions) in the selected period.",
  stats_busiest_day_tooltip:
    "The day of the week with the most bookings in the selected period.",
  stats_busiest_hour_tooltip:
    "The hour of the day with the most bookings in the selected period.",
  stats_peak_times_tooltip:
    "The day and hour with the most <b>approved</b> and <b>done</b> bookings in the selected period.",
  stats_bookings_by_hour_tooltip:
    "How bookings are distributed across hours of the day in the selected period.",
  stats_bookings_by_service_tooltip:
    "Which services received the most bookings in the selected period.",
  stats_bookings_by_employee_tooltip:
    "Which team members handled the most bookings in the selected period.",
  stats_booking_lead_time_tooltip:
    "How far in advance clients typically book — the number of days between booking creation and the booking date.",
  stats_bookings_by_location_tooltip:
    "How bookings are distributed across your business locations in the selected period.",
  stats_average_lead_time_tooltip:
    "The average number of days between when a booking is created and when it takes place.",
  stats_median_lead_time_tooltip:
    "The median number of days between when a booking is created and when it takes place. Less affected by outliers than the average.",
  stats_low_estimate_tooltip:
    "The lower end of the forecast — your results might be around this level if the next period is slower than usual.",
  stats_high_estimate_tooltip:
    "The upper end of the forecast — the optimistic scenario for the next period.",
  stats_booking_status_tooltip:
    "Breakdown of your bookings by status — <b>approved</b>, <b>done</b>, and <b>cancelled</b> — in the selected period.",
  stats_avg_booking_value_tooltip:
    "The average amount paid per booking in the selected period.<br><br><b>Formula:</b> booking revenue ÷ number of paid bookings",
  stats_mrr_tooltip:
    "Total revenue from subscription plan payments in the selected period. Shows the sum of all paid subscription transactions, not a normalized monthly rate.",
  stats_top_clients_tooltip:
    "Your highest-spending clients in the selected period, ranked by total revenue.",
  stats_top_service_tooltip:
    "The service with the most bookings in the selected period.",
  stats_bookings_timeline_tooltip:
    "How the number of bookings changed in the selected period. Includes <b>approved</b> and <b>done</b> bookings.<br><br><b>Forecast:</b> dashed line shows upcoming periods — bookings that are already scheduled (<b>approved</b> or <b>awaiting payment</b>).",
  stats_peak_hours_heatmap_tooltip:
    "Heatmap showing when most bookings happen — by day of the week and hour of the day. Darker cells = more bookings.",
  stats_booking_revenue_tooltip:
    "Revenue from booking payments only in the selected period — excludes product sales and subscriptions.",
  stats_total_transactions_tooltip:
    "Total number of payment transactions processed in the selected period, across all payment sources.",
  stats_revenue_timeline_tooltip:
    "Revenue broken down by source — bookings, subscriptions, and products. Only completed payments, based on the payment date. Click legend items to show or hide lines.<br><br><b>Forecast</b>: dashed lines show projected revenue — from bookings already paid or awaiting payment, plus estimated income from active subscriptions.",
  stats_revenue_top_services_table_tooltip:
    "Services ranked by revenue in the selected period.",
  stats_revenue_top_products_table_tooltip:
    "Products ranked by revenue in the selected period.",
  stats_payment_providers_chart_tooltip:
    "Number of <b>completed</b> transactions by payment method (e.g. Stripe, cash, card) in the selected period.",
  stats_payment_methods_count_chart_tooltip:
    "How many transactions were processed through each payment method in the selected period.",
  stats_payment_methods_value_chart_tooltip:
    "Total revenue collected through each payment method in the selected period.",
  stats_booking_status_chart_tooltip:
    "Bookings by status — <b>approved</b>, <b>done</b>, <b>cancelled</b>, and <b>awaiting payment</b> — in the selected period.",
  stats_cancellation_reasons_chart_tooltip:
    "Most common reasons clients cancelled their bookings in the selected period.",
  stats_busiest_day_chart_tooltip:
    "Which days of the week have the most bookings in the selected period.",
  stats_delivery_type_chart_tooltip:
    "How bookings are split across delivery types — in-person, online, phone, etc. — in the selected period.",
  stats_customer_segments_chart_tooltip:
    "How engaged your active clients are in the selected period:<br>• <b>First-time</b> — first booking ever, no prior history<br>• <b>Came back</b> — had bookings before, visited once in this period<br>• <b>Loyal</b> — had bookings before and came 2+ times in this period",
  stats_top_customers_table_tooltip:
    "Total spent in the selected period — includes all customer payments: bookings, subscriptions and products.",
  stats_employee_table_tooltip:
    "Performance overview for each team member — bookings, hours, and occupancy in the selected period.",
  stats_service_table_tooltip:
    "Performance overview for each service — bookings and revenue in the selected period.",
  stats_services_by_category_tooltip:
    "Number of approved and done bookings per service category in the selected period.",
  stats_booking_revenue_timeline_tooltip:
    "How booking revenue changed over time in the selected period.",
  stats_subscription_revenue_timeline_tooltip:
    "How subscription revenue changed over time in the selected period.",
  stats_product_revenue_timeline_tooltip:
    "How product revenue changed over time in the selected period.",
  stats_subscription_timeline_tooltip:
    "Number of new subscriptions started per period.",
  stats_top_subscriptions_table_tooltip:
    "Subscription plans ranked by revenue in the selected period.",
  stats_top_products_table_tooltip:
    "Products ranked by revenue in the selected period.",
  stats_not_assigned: "Not assigned",
  stats_low: "Low",
  stats_medium: "Medium",
  stats_high: "High",
  stats_insufficient: "Insufficient data",
  stats_type_name: "Delivery type",
  stats_new_subscriptions: "New subscriptions",
  stats_new: "New",
  stats_returning: "Returning",
  stats_first_time: "First-time",
  stats_first_time_tooltip:
    "Clients with no bookings before the selected period — this is their first visit.",
  stats_came_back: "Came back",
  stats_came_back_tooltip:
    "Clients who had bookings before the selected period and booked once in this period.",
  stats_loyal: "Loyal",
  stats_loyal_tooltip:
    "Clients who had bookings before the selected period and booked 2+ times in this period.",
  stats_staff: "Staff",
  stats_payment_timeout: "Payment timeout",
  stats_calendar_sync: "Calendar sync",
  stats_in_person: "Address",
  stats_phone: "Phone",
  stats_other: "Other",
  stats_stripe: "Stripe",
  stats_cash: "Cash",
  stats_card: "Card",
  stats_transfer: "Transfer",
  stats_google_meet: "Google Meet",
  stats_zoom: "Zoom",
  stats_microsoft_teams: "Microsoft Teams",
  stats_skype: "Skype",
  stats_whatsapp: "WhatsApp",
  stats_client: "Customer",
  stats_no_payment: "Payment timeout",
  stats_external: "Calendar sync",
  bulk_operation_progress: "Processing: @{done} of @{total}",
  bulk_operation_counting: "Counting records...",
  bulk_action_delete_events: "Deleting events",
  bulk_action_delete_users: "Deleting users",
  bulk_action_update_users: "Updating users",
  bulk_action_export_users: "Exporting users",
  bulk_action_add_to_group: "Adding to groups",
  bulk_action_remove_from_group: "Removing from groups",
  bulk_action_send_notification: "Sending notifications",
  bulk_action_update_bookings: "Updating bookings",
  bulk_action_export_events: "Exporting events",
  bulk_action_export_unavailable_booking_slots: "Exporting blackout dates",
  bulk_action_update_employees: "Updating employees",
  bulk_action_delete_employees: "Deleting employees",
  bulk_action_delete_resources: "Deleting resources",
  bulk_action_delete_tags: "Deleting labels",
  bulk_action_delete_groups: "Deleting groups",
  bulk_action_delete_locations: "Deleting locations",
  bulk_action_delete_availability_schedules: "Deleting availability schedules",
  bulk_action_delete_subscriptions: "Deleting subscriptions",
  bulk_action_delete_store_products: "Deleting products",
  bulk_action_delete_store_transactions: "Deleting transactions",
  bulk_action_delete_user_subscriptions: "Deleting customer subscriptions",
  bulk_action_cancel_user_subscriptions: "Canceling customer subscriptions",
  bulk_action_delete_newsletter: "Deleting newsletter addresses",
  bulk_action_export_newsletter: "Exporting the newsletter",
  bulk_action_delete_websites: "Deleting websites",
  bulk_action_disable_websites: "Disabling websites",
  bulk_action_delete_mobile_apps: "Deleting mobile apps",
  bulk_action_export_employees: "Exporting employees",
  bulk_notification_sending: "Sending notifications...",
  bulk_export_generating: "Generating file...",
  bulk_export_sent_to_email: "File sent to your email",
  bulk_export_sent_to_email_with_errors:
    "File sent to your email. Processed: @{processed}, failed: @{failed}.",
  download_csv: "Download CSV",
  selection_all_on_page: "All @{amount} records on this page are selected.",
  selection_select_all_records: "Select all @{total} records across all pages",
  selection_all_records_selected:
    "All @{total} records across all pages are selected.",
  your_overview: "Your overview",
  add_widget: "Add widget",
  widget_group_revenue: "Revenue",
  widget_group_bookings: "Bookings",
  widget_group_clients: "Clients",
  widget_group_team: "My team",
  widget_group_subscriptions: "Subscriptions",
  widget_group_products: "Products",
  widget_revenue_kpi: "Revenue",
  widget_bookings_kpi: "Bookings",
  widget_new_clients_kpi: "New clients",
  widget_cancellation_rate: "Cancellation rate",
  widget_top_clients: "Top clients",
  widget_peak_hours_heatmap: "Peak hours",
  widget_avg_booking_value: "Avg booking value",
  widget_payment_method: "Preferred payment method",
  widget_bookings_timeline: "Bookings timeline",
  widget_booking_status: "Booking status",
  widget_busiest_day: "Busiest day",
  widget_busiest_hour: "Busiest hour",
  widget_avg_lead_time: "Avg lead time",
  widget_active_clients: "Active clients",
  widget_retention_rate: "Retention rate",
  widget_employee_utilization: "Schedule occupancy",
  widget_top_service: "Top service",
  widget_active_subscriptions: "Active subscriptions",
  widget_mrr: "Subscription revenue",
  widget_product_revenue: "Product revenue",
  widget_booking_revenue: "Booking revenue",
  widget_total_transactions: "Total transactions",
  widget_payment_conversion: "Booking payment rate",
  widget_revenue_timeline: "Revenue timeline",
  widget_revenue_top_services_table: "Top services by revenue",
  widget_revenue_top_products_table: "Top products by revenue",
  widget_payment_providers_chart: "Payment methods",
  widget_booking_status_chart: "Booking status breakdown",
  widget_cancellation_reasons_chart: "Cancellation reasons",
  widget_busiest_day_chart: "Bookings by day of week",
  widget_delivery_type_chart: "Delivery type breakdown",
  widget_customer_segments_chart: "Client segments",
  widget_top_customers_table: "Top clients (full table)",
  widget_employee_table: "Employee performance",
  widget_service_table: "Service performance",
  widget_subscription_timeline: "New subscriptions over time",
  widget_subscription_revenue_timeline: "Subscription revenue over time",
  widget_top_subscriptions_table: "Top subscription plans",
  widget_product_revenue_timeline: "Product revenue over time",
  widget_top_products_table: "Top products",
  widget_booking_revenue_timeline: "Booking revenue over time",
  widget_bookings_by_service_table: "Bookings by service",
  widget_bookings_by_employee_table: "Top team members",
  widget_bookings_by_hour_chart: "Bookings by hour",
  widget_locations_table: "Bookings by location",
  widget_total_clients: "Total clients",
  widget_customer_ltv: "Client lifetime value",
  widget_returning_clients: "Returning clients",
  widget_avg_days_between_visits: "Avg days between visits",
  widget_first_time_clients: "First-time clients",
  widget_loyal_clients: "Loyal clients",
  widget_services_by_category_chart: "Bookings by category",
  widget_renewal_rate: "Renewal rate",
  widget_subscription_utilization: "Subscription utilization",
  widget_unused_booking_slots: "Unused booking slots",
  widget_total_products_sold: "Total products sold",
  restore_defaults: "Restore defaults",
  restore_defaults_warning:
    "This will reset your dashboard to the default widgets. Your current layout will be lost.",
  drag_to_reorder: "Drag to reorder",
  tooltip_add_widget: "Add a new widget to your dashboard",
  tooltip_edit_layout: "Rearrange or remove widgets",
  tooltip_restore_defaults: "Reset to the default widget layout",
  tooltip_save_layout: "Save your current widget layout",
  tooltip_remove_widget: "Remove this widget",
  add_more_widgets: "Add more widgets",
  all_time: "All time",
  remove_from_group: "Remove from group",
  change_status_to_approved: "Set as approved",
  change_status_to_payment: "Set as awaiting payment",
  change_status_to_cancelled: "Set as cancelled",
  change_status_to_done: "Set as done",
  bulk_operation_already_active:
    "You already have an active bulk operation. Please wait for it to complete.",
  go_to_fakturownia: "Go to InvoiceOcean settings",
  invoice_no_integration_tooltip:
    "Invoice enabled but InvoiceOcean integration is not active",
  affiliate: "Affiliate Program",
  affiliate_page_title: "Affiliate Program",
  affiliate_join_title: "Join the Affiliate Program",
  affiliate_join_description:
    "Share your unique link and earn for every new customer who subscribes to Calendesk.",
  affiliate_accept_terms: "I accept the referral program terms",
  affiliate_terms_link_text: "Read the terms",
  affiliate_join_button: "Join Program",
  affiliate_balance_title: "Affiliate Balance",
  affiliate_link_title: "Your Affiliate Link",
  affiliate_link_description:
    "Share this link to refer new customers and start earning.",
  affiliate_copy_link: "Copy link",
  affiliate_link_copied: "Link copied to clipboard!",
  affiliate_request_payout: "Request Payout",
  affiliate_payout_method_title: "Choose payout method",
  affiliate_payout_balance_credit: "Balance Credit",
  affiliate_payout_balance_credit_description:
    "Apply your earnings as a credit to reduce your subscription cost.",
  affiliate_payout_bank_transfer: "Bank Transfer",
  affiliate_payout_bank_transfer_info:
    "To request a bank transfer (min. {minAmount} net), send an invoice to support@calendesk.com after submitting.",
  affiliate_payout_bank_transfer_below_min:
    "Bank transfer requires at least {minAmount}. Earn a bit more or use the balance credit option.",
  affiliate_payout_confirm: "Confirm Payout",
  affiliate_payout_success: "Payout request submitted successfully.",
  affiliate_join_success: "You've joined the affiliate program.",
  affiliate_no_referrals: "No referrals yet. Share your link to start earning!",
  affiliate_no_payouts: "No transactions yet.",
  affiliate_referrals_title: "Referrals",
  affiliate_payouts_title: "Transaction history",
  affiliate_status_pending: "Pending",
  affiliate_status_rewarded: "Rewarded",
  affiliate_status_rejected: "Rejected",
  affiliate_status_approved: "Approved",
  affiliate_status_completed: "Completed",
  affiliate_payout_method_balance: "Balance credit",
  affiliate_payout_method_bank: "Bank transfer",
  affiliate_payout_method_adjustment: "Adjustment",
  affiliate_welcome_bonus_banner:
    "You have a welcome bonus! {amount} off your first subscription.",
  affiliate_welcome_bonus_applied: "Welcome bonus: -{amount}",
  affiliate_welcome_bonus_plan_note: "-{amount} off your first payment",
  first_payment: "First payment",
  affiliate_welcome_bonus_dashboard_title: "A welcome bonus is waiting",
  affiliate_welcome_bonus_dashboard_description:
    "Claim {amount} off your first Calendesk subscription.",
  affiliate_welcome_bonus_dashboard_cta: "Choose a plan",
  affiliate_column_tenant: "Client",
  affiliate_column_registered: "Registered",
  affiliate_column_subscribed: "Subscribed",
  affiliate_column_status: "Status",
  affiliate_column_reward: "Reward",
  affiliate_column_date: "Date",
  affiliate_column_amount: "Amount",
  affiliate_column_method: "Type",
  affiliate_column_note: "Reason",
  affiliate_modal_headline: "Earn by recommending Calendesk",
  affiliate_modal_cta_dismiss: "Maybe later",
  affiliate_accept_terms_with_link_prefix: "I accept the",
  affiliate_accept_terms_with_link_anchor: "referral program terms",
  affiliate_total_earned: "Total earned",
  affiliate_total_paid: "Total paid",
  affiliate_hero_badge_new: "NEW",
  affiliate_hero_badge_label: "Referral program for your business",
  affiliate_hero_headline_main: "Share your link. Earn on every",
  affiliate_hero_headline_accent: "booking.",
  affiliate_hero_subhead:
    "Every new customer you bring earns you a commission, paid automatically. Track everything live in your Calendesk panel.",
  affiliate_hero_cta_primary: "Join the program",
  affiliate_hero_cta_secondary: "View terms",
  affiliate_hero_headline:
    "Refer Calendesk: 50 PLN for you and 50 PLN for the new business!",
  affiliate_hero_lead:
    "Accept the terms, join the program, and grab your referral link. For every customer who creates a Calendesk account and pays for a subscription, you'll earn a reward. The referred business wins too: they get a welcome bonus.",
  affiliate_hero_fine_print:
    "Program runs 01.04.2026 – 31.03.2028. 2,000 PLN gross cap for participants without a registered business. Settlements in PLN, USD, EUR or GBP.",
  affiliate_reward_you_label: "You get",
  affiliate_reward_you_amount: "50 PLN",
  affiliate_reward_you_suffix: "net",
  affiliate_reward_you_note: "for every new business on Calendesk",
  affiliate_reward_new_label: "The new business gets",
  affiliate_reward_new_amount: "50 PLN",
  affiliate_reward_new_suffix: "net",
  affiliate_reward_new_note: "discount code for the Calendesk subscription",
  affiliate_preview_copy: "Copy",
  affiliate_preview_saldo_label: "Balance · this month",
  affiliate_preview_delta: "+7 referrals",
  affiliate_preview_last_reward_title: "Latest reward",
  affiliate_preview_paid_out: "Paid out",
  affiliate_preview_recent_title: "Recent referrals",
  affiliate_preview_recent_count: "7 this month",
  affiliate_preview_col_business: "Business",
  affiliate_preview_col_reward: "Reward",
  affiliate_preview_col_status: "Status",
  affiliate_preview_status_reward: "REWARD",
  affiliate_preview_status_30days: "30 DAYS",
  affiliate_hero_preview_link_title: "Your referral link",
  affiliate_hero_preview_link_description:
    "Share it with clients and friends. The commission is yours.",
  affiliate_hero_preview_this_month: "This month",
  affiliate_hero_preview_trend: "+34% vs. last month",
  affiliate_hero_preview_recent_title: "Recent referrals",
  affiliate_hero_preview_recent_count: "12 this month",
  affiliate_hero_sample_data:
    "Sample data. Your real numbers appear once you join.",
  affiliate_hero_preview_label: "Preview",
  affiliate_announcement_title: "Grab 50 PLN each: you and your friends!",
  affiliate_announcement_description:
    "Share your link. When a new business pays for a subscription, you both get 50 PLN.",
  affiliate_announcement_description_2:
    "Withdraw your reward by bank transfer or use it to pay for your own Calendesk account.",
  affiliate_announcement_cta_learn_more: "Learn more",
  affiliate_announcement_cta_dismiss: "Maybe later",
  affiliate_hero_benefit_1:
    "Earn on every new subscription. Unlimited referrals*",
  affiliate_hero_benefit_2:
    "The referred business gets a discount code on their subscription",
  affiliate_hero_benefit_3: "Live referral tracking in your panel",
  affiliate_suspended_title: "Your affiliate program is suspended",
  affiliate_suspended_message:
    "New payouts are paused and the Calendesk team is reviewing your account. Contact support if you have questions.",
  affiliate_rejection_cancelled_before_30d:
    "Referred tenant cancelled before the 30-day qualification window passed.",
  affiliate_rejection_duplicate_tenant:
    "Referred tenant was already in our system as a duplicate account.",
  affiliate_rejection_fraud: "Flagged as fraudulent or unauthorized referral.",
  affiliate_rejection_lifetime_cap_exceeded:
    "Your program reached its lifetime earnings cap.",
  affiliate_rejection_note_label: "Note from support:",
  affiliate_leave_program: "Leave the affiliate program",
  affiliate_leave_dialog_title: "Leave the affiliate program?",
  affiliate_leave_dialog_warning:
    "You'll stop earning new rewards and your affiliate link will stop working.",
  affiliate_leave_dialog_rejoin_hint:
    "You can rejoin anytime. Your code and history are saved.",
  affiliate_leave_dialog_confirm: "Leave program",
  affiliate_leave_success: "You left the affiliate program.",
  affiliate_preview_copy_locked:
    "Accept the terms and join the program to generate your link.",
  affiliate_code_title: "Your referral code",
  affiliate_code_description:
    "Clients can type this code when they buy their first subscription.",
  affiliate_copy_code: "Copy code",
  affiliate_code_copied: "Code copied to clipboard!",
  affiliate_terms_title: "Your terms",
  affiliate_terms_description:
    "Individual terms agreed with Calendesk. They take precedence over the standard terms of the program.",
  affiliate_terms_reward_monthly: "Reward per client on a monthly plan",
  affiliate_terms_reward_yearly: "Reward per client on a yearly plan",
  affiliate_terms_amount_net: "{amount} net",
  affiliate_terms_percent_yearly:
    "{percent}% of what the client pays net for the first year",
  affiliate_terms_percent_monthly:
    "{percent}% of what the client pays net for the first 3 months",
  affiliate_terms_discount: "Client discount",
  affiliate_terms_discount_value: "{amount} off the first subscription payment",
  affiliate_terms_qualification: "Qualification period",
  affiliate_terms_qualification_value:
    "{days} days from the client's first payment",
  affiliate_terms_payout: "Payout",
  affiliate_terms_payout_value:
    "From {amount} net, by bank transfer against your invoice",
  affiliate_terms_own_tax_id:
    "The client buys the subscription with its own details and its own tax ID. An account paid with your tax ID, or with a tax ID that has already paid, earns no reward.",
  affiliate_contact_title: "Your Calendesk contact",
  affiliate_contact_description:
    "Questions about your terms, clients or payouts? Write to your contact.",
  affiliate_column_plan: "Plan",
  affiliate_column_source: "Source",
  affiliate_column_qualifies_at: "Qualifies on",
  affiliate_plan_month: "Monthly",
  affiliate_plan_year: "Yearly",
  affiliate_source_link: "Link",
  affiliate_source_code: "Code",
  affiliate_source_admin: "Added by Calendesk",
  affiliate_rejection_cancelled_before_qualification:
    "The referred client cancelled before the qualification period ended.",
  affiliate_rejection_refunded: "The referred client's payment was refunded.",
  affiliate_rejection_not_covered_by_payments:
    "The client's net payments in the qualification period were lower than the reward.",
  affiliate_rejection_returning_customer:
    "The client has already paid for Calendesk before (same e-mail or tax ID).",
  affiliate_rejection_partner_account:
    "The account belongs to a Calendesk partner or was paid with your tax ID.",
  fakturownia_department_id_title: "Department ID",
  fakturownia_department_id_hint: "Leave empty to use the default department.",
  fakturownia_department_id_description:
    "Numeric ID of the InvoiceOcean department that should issue invoices from Calendesk. Each department can have its own seller data and default notes — useful when one InvoiceOcean account is shared across multiple sales channels (e.g. Shopify + Calendesk).",
  fakturownia_additional_settings_title: "Additional settings",
  fakturownia_additional_settings_subtitle:
    "These fields are optional and not required for a default integration. Fill them in only if you want to customize how invoices are issued.",
  fakturownia_credentials_error:
    "Cannot connect to InvoiceOcean with these credentials. Check the API token and account URL.",
  fakturownia_department_id_single_hint:
    "Your InvoiceOcean account has only one department. Create another department in InvoiceOcean to route invoices separately.",
  fakturownia_department_id_no_results:
    "No departments found on this InvoiceOcean account.",
  google_calendar_auth_error:
    "Google Calendar could not be connected because access was denied or not all required permissions were granted. Please try again and allow access to your calendar.",
  outlook_calendar_auth_error:
    "Outlook Calendar could not be connected because access was denied or not all required permissions were granted. Please try again and allow access to your calendar.",
  gov_status_demo_ok: "Demo (accepted)",
  availability_status: "Status",
  availability_period: "Period",
  availability_status_active: "Active",
  availability_status_active_tooltip:
    "This schedule is currently active and applied to at least one employee or service.",
  availability_status_planned: "Planned",
  availability_status_planned_tooltip:
    "This schedule will become active on a future date based on its assignment period.",
  availability_status_inactive: "Inactive",
  availability_status_inactive_tooltip:
    "This schedule was active in the past but its assignment period has already ended.",
  availability_status_unassigned: "Unassigned",
  availability_status_unassigned_tooltip:
    "This schedule has no assignments to any employee or service.",
  availability_period_none: "–",
  availability_period_indefinite: "Indefinitely",
  availability_period_various: "Various periods",
  availability_period_no_start: "From the beginning",
  availability_period_no_end: "Indefinitely",
  availability_period_assigned_to: "Assigned to",
  edit_schedule: "Edit schedule",
  services_and_categories: "Services and categories",
  included_in_selected_category: "Included in the selected category",
  availability_schedule_color: "Schedule color",
  availability_schedule_color_tooltip:
    "The schedule's color in the availability preview. Set it to tell schedules apart when an employee or service has more than one.",
  employee_color_tooltip:
    "This color marks the employee's bookings in the calendar. Set it to spot at a glance whose booking it is.",
  availability_period_from: "Start date",
  availability_period_to: "End date",
  availability_period_no_end_date: "No end date",
  availability_period_no_start_date: "No start date",
  availability_period_days: "@{count} days",
  availability_period_day_one: "1 day",
  availability_assign_type_locked:
    "This schedule is already assigned to a different target type (employees or services). Mixing types is not allowed.",
  availability_overlap_title: "Overlapping periods",
  availability_schedules: "Availability schedules",
  availability_calendar_preview: "Schedules preview",
  availability_calendar_select_target: "Select a target to see the preview.",
  availability_calendar_no_schedule: "No schedule",
  availability_calendar_day_off: "Day off",
  availability_exception_hours_prefilled:
    "Hours copied from your standard schedule for this weekday. You can adjust them just for this exception.",
  availability_schedule_created:
    "Schedule created. Assign it to employees or services so clients can book.",
  availability_exception_day_off:
    "Day off – based on the standard week. Add hours to make this day available.",
  availability_calendar_show_for: "Show availability for",
  availability_preview_info:
    "The preview shows which schedule applies on which day and what hours it produces. Client booking slots live in the booking calendar.",
  availability_view_team: "Team plan",
  availability_view_year: "Year",
  availability_view_month: "Month",
  availability_test_info:
    "Test availability the way clients see it: pick a location, service and employee. Free slots come from the same booking engine as your booking page.",
  availability_test_location_online: "Online",
  availability_test_location_phone: "Phone",
  availability_test_no_location: "No location",
  availability_test_any_employee: "Any employee",
  availability_test_variant: "Variant",
  availability_view_day: "Day",
  availability_view_week: "Week",
  availability_test_morning: "Morning",
  availability_test_afternoon: "Afternoon",
  availability_test_evening: "Evening",
  availability_test_free_slots: "free slots",
  availability_test_available_employees: "employees available",
  availability_test_first_slot: "first slot",
  availability_test_no_slots: "No slots",
  availability_test_none_short: "None",
  availability_test_pick_service: "Pick a service to test availability",
  availability_test_unbookable:
    "Clients won't see any time here. Check this employee's schedule in the Schedules preview tab, or their working hours.",
  availability_test_week_hint:
    "A full row with no slots means the employee is unbookable all week.",
  availability_preview_profile_hours_info:
    "This employee has no assigned schedule. The working hours set in their profile apply (the old work schedule).",
  availability_preview_profile_hours_short: "Profile working hours",
  availability_preview_service_fallback_info:
    "This service has no schedule of its own. Available times come from the schedules of the employees who provide it.",
  availability_preview_service_fallback_short: "Employees' schedules",
  previous_month: "Previous month",
  next_month: "Next month",
  availability_calendar_no_availability_hint:
    "This day is outside the schedule. Clients won't see any available times.",
  availability_period_title: "Validity period",
  availability_period_dialog_info:
    "Set the period during which the schedule applies to this assignment. Within a single employee or a single service, schedule periods cannot overlap.",
  availability_set_period: "Set validity period",
  availability_set_period_assign_first:
    "First assign the schedule to employees or services",
  availability_timeline_caption_single:
    "Timeline of this assignment's schedules (@{year})",
  availability_timeline_caption_multi_employees:
    "Timeline for @{count} selected employees (@{year})",
  availability_timeline_caption_multi_services:
    "Timeline for @{count} selected services (@{year})",
  availability_overlap_days: "Overlapping days",
  availability_today_short: "today",
  availability_schedule_label: "Schedule",
  availability_overlap_conflict_target:
    "“@{target}” already has the schedule “@{name}” in this period (@{from} – @{to}).",
  availability_overlap_resolve_hint:
    "Change this period or shorten the periods of the schedules listed above to save your changes.",
  copy_suffix: "(copy)",
  availability_schedule_duplicated: "Schedule has been duplicated",
  availability_unassign_employees_first: "Remove the assigned employees first",
  availability_unassign_services_first: "Remove the assigned services first",
  availability_schedule_timezone_differs_info:
    "Hours in this schedule use the @{timezone} time zone, which is different from yours (@{user_timezone}). For example, 09:00 in this schedule is @{example} for you.",
  availability_timezone_previous_day: "the previous day",
  availability_timezone_next_day: "the next day",
  availability_timezone_differs_tooltip:
    "This schedule uses a different time zone than yours (@{timezone}).",
  employee_working_hours_timezone_info:
    "These hours use your business's time zone (@{timezone}), which is different from yours (@{user_timezone}).",
  color_group_pastel: "Pastel",
  color_group_solid: "Solid colors",
  wb_settings_group_website: "Website and SEO",
  wb_settings_group_booking: "Bookings",
  wb_settings_group_client_account: "Customer account",
  wb_settings_group_header_footer: "Header and footer",
  wb_settings_group_advanced: "Integrations and advanced",
  wb_settings_filter: "Search settings",
  wb_settings_filter_empty: "No setting matches your search.",
  wb_hide_booking_prices: "Hide prices in customer bookings",
  wb_hide_booking_prices_tooltip:
    "Customers won't see prices on their booking list after logging in.",
  wb_hide_payments: "Hide the payments section in the customer account",
  wb_hide_payments_tooltip:
    "Logged-in customers won't see the payments tab, their transaction history, or the saved-card section.",
  wb_hide_profile_billing_data: "Hide billing details in the customer account",
  wb_hide_profile_billing_data_tooltip:
    "Customers can't fill in billing details in their account settings. Sign-up and booking forms stay unchanged.",
  wb_hide_profile_photo_upload: "Disable profile photo changes",
  wb_hide_profile_photo_upload_tooltip:
    "Customers can't upload their own profile photo in their account.",
  wb_favicon_url_tooltip:
    "The icon shown on the browser tab. Copy the URL from the photo gallery: click an image preview and you'll see its address at the bottom.",
  wb_og_image_url_tooltip:
    "The image shown when someone shares a link to your website, e.g. on Facebook (og:image). Copy the URL from the photo gallery: click an image preview and you'll see its address at the bottom.",
  wb_newsletter_success_url_tooltip:
    "The address customers land on after signing up for the newsletter. Leave it empty to keep them on the page.",
  wb_account_activation_success_url_tooltip:
    "The address customers land on after clicking the activation link in their email.",
  wb_section_group_content: "Content",
  wb_section_group_offer: "Offer",
  wb_section_group_booking_flow: "Booking flow",
  wb_section_group_form: "Form",
  wb_section_group_account: "Customer account",
  wb_section_group_menu: "Pages and navigation",
  wb_section_group_company: "Company details and social media",
  wb_section_group_images: "Images and gallery",
  wb_section_group_map: "Map",
  wb_section_group_appearance: "Appearance",
  wb_section_group_other: "Other",
  wb_section_group_booking_form: "Booking form",
  html_editor_tooltip_fullscreen: "Full screen",
  html_editor_tooltip_fullscreen_exit: "Exit full screen",
  wb_setting_tooltip_help_link: "Click to open the guide",
  wb_enable_discounts_tooltip:
    "When paying for a booking, subscription or product, customers see a field for a discount code. You create the codes themselves in Stripe, in the coupons section.",
  wb_enable_discounts_tooltip_url:
    "https://calendesk.com/help/how-do-you-create-discount-codes",
  wb_hide_booking_employees_tooltip:
    "Customers won't see any employee names while booking, they only pick a service and a time. This setting covers the website only, so review your notification templates in the Calendesk panel and remove employee details there if customers should not see them.",
  wb_hide_time_zone_tooltip:
    "Customers won't see the time-zone switch next to the calendar. Times are shown in the zone detected from their browser, and when that zone is not supported, in your company's zone (@{timeZone}).",
  gdpr_fields: "Customer consents",
  gdpr_field_required: "required consent",
  wb_account_title_tooltip:
    "Heading above the customer account links in the footer. Below it the customer sees sign in and sign up, and once logged in, their bookings and settings.",
  wb_align_center_tooltip:
    "Places the section content in the middle of its height instead of at the top edge. You will see the difference mostly in tall sections with little text.",
  wb_any_employee_enabled_tooltip:
    'Checked: the employee step fills itself in with "any person" and the customer goes straight to picking a time, while the "Change" button still lets them pick a specific person. Unchecked: the customer picks a person themselves from a list where "any person" is the first option.',
  wb_book_now_label_tooltip:
    'Your own text on the button the customer clicks to confirm the selected time. If you leave the field empty, the button shows the standard label "Book".',
  wb_booking_dynamic_form_tooltip:
    "Add your own questions to the booking form, for example a notes field or a file attachment. You can assign each field to selected services, so the customer only sees it when booking those services.",
  wb_button_tooltip:
    "The button in this section. Set its label and the page the customer goes to after clicking.",
  wb_button_size_tooltip:
    "The size of the buttons in the top bar of your website. Choose from XS (very small) to XL (very large).",
  wb_buttons_tooltip:
    "The buttons shown in this section. Each one has its own label and takes the customer to a page you choose.",
  wb_buttons_position_tooltip:
    "Sets where the buttons sit in the section: at the left edge, in the center or at the right.",
  wb_calendar_max_date_tooltip:
    "The customer can browse and book times up to the day you choose at the latest. The calendar does not show any dates beyond that.",
  wb_calendar_min_date_tooltip:
    "The customer sees available times only from the day you choose. Earlier dates cannot be browsed or booked, useful for example when bookings open on a specific date.",
  wb_color_bg_tooltip:
    "The background color of most sections on your website. Sections with “Invert colors” turned on use the second background instead.",
  wb_color_bg_2_tooltip:
    "The spare background color. It shows in sections with “Invert colors” turned on, so you can alternate two background colors across the page.",
  wb_color_primary_tooltip:
    "The main color of your website. You will see it on buttons, links and highlighted elements, for example in the booking calendar.",
  wb_color_text_tooltip:
    "The text color in sections with the first background. Pick one that clearly stands out from the background color, otherwise the text will be hard to read.",
  wb_color_text_2_tooltip:
    "The text color in sections with the second background. Make sure it contrasts clearly with the second background color.",
  wb_column_width_tooltip:
    "How much of the section width one review takes up on a computer. Enter a percentage, for example 50 gives two reviews side by side and 33 gives three. On phones, reviews always take the full width.",
  wb_company_address_tooltip:
    "Your company address shown in the footer of the page, in the contact part.",
  wb_company_email_tooltip:
    "The email address in the footer of the page. When the customer clicks it, a new message addressed to you opens.",
  wb_company_name_tooltip:
    "Your company name shown in the top bar of the page. Write it the way you want customers to see it.",
  wb_company_phone_tooltip:
    "The phone number in the footer of the page. On a phone the customer can tap it to call you right away.",
  wb_company_slogan_tooltip:
    "A short slogan for your company, shown under the logo in the booking section. One sentence that tells the customer what you do.",
  wb_container_fluid_tooltip:
    "Stretches the section content across the full width of the browser window. Turned off: the content stays in a narrower column in the center, which usually looks calmer on large screens.",
  wb_count_places_in_dates_tooltip:
    "For group services, the customer sees the total number of free places next to the date instead of the number of free times. It works only for services that more than one person can attend.",
  wb_custom_code_tooltip:
    "A place for your own code, for example a chat, statistics or ad pixel script. The code you paste works on all subpages. This option is for advanced users.",
  wb_cycle_tooltip:
    "The photos in the gallery move on their own, with no clicking. You set how fast in the “Speed of changes in milliseconds” field.",
  wb_dark_mode_tooltip:
    "Switches the whole website to dark colors. Match it with dark backgrounds and light text colors so everything stays readable.",
  wb_date_label_tooltip:
    'Your own label for the field where the customer picks the day of the booking, for example "Choose the day of your appointment".',
  wb_description_tooltip:
    "Text shown under the section heading. Describe briefly what you offer or what the customer will find in this part of the page.",
  wb_elevation_tooltip:
    "How strong the shadow under the top bar of the website is, from 0 (no shadow) to 24 (strong shadow). The shadow visually separates the bar from the page content.",
  wb_email_form_success_url_tooltip:
    "After sending the form, the customer goes to the address you enter here, for example a thank-you page. When you set it, the message about the form being sent is not shown.",
  wb_email_sent_tooltip:
    'The text that appears in place of the form after it is sent, for example "Thank you, we will get back to you soon". A customer you redirect to another address will not see it.',
  wb_email_subject_tooltip:
    'You will see this text as the subject of the email with the form answers. Set something recognizable, for example "Enquiry from the website", so you can find these messages easily in your inbox.',
  wb_employee_info_label_tooltip:
    'A short text shown above the list of employees, for example "Choose the person you want to book with". It appears only when the customer has someone to choose from, that is when more than one person performs the service.',
  wb_employee_label_tooltip:
    'Your own label for the drop-down list where the customer picks an employee, for example "Specialist" or "Therapist".',
  wb_employee_list_tooltip:
    "Choose which employees should be visible in this section of the page. The customer sees only the selected people, in the order from the list.",
  wb_employee_search_tooltip:
    "A search field for looking up employees by last name appears above the list. The customer sees it only when there are at least five employees on the list.",
  wb_end_calendar_time_tooltip:
    "The last hour visible in the weekly calendar on your page. Times after this hour are not shown, set it so that it covers your working hours.",
  wb_expand_collapse_service_panels_tooltip:
    "The list of services is collapsed into categories, and the customer expands the group they are interested in with one click. Useful when you have many services and a long list becomes hard to read.",
  wb_facebook_tooltip:
    "A link to your Facebook profile. Once you enter it, a Facebook icon appears on the page and leads to your profile.",
  wb_features_tooltip:
    "A list of items shown in this section as tiles, for example the benefits of your offer or customer reviews. Each item has its own title, description and image.",
  wb_forgotten_password_confirmation_modal_tooltip:
    "Settings for the message the customer sees after requesting a new password. It confirms that the password reset link went to the email they gave.",
  wb_forgotten_password_modal_tooltip:
    "Settings for the window where the customer enters their email to set a new password for their customer account.",
  wb_forgotten_password_modal_confirmation_subtitle_tooltip:
    "The content of the message shown after the password change email is sent. Tell the customer that the link is in their inbox and what to do if the email did not arrive.",
  wb_forgotten_password_modal_confirmation_title_tooltip:
    'Heading of the message the customer sees after requesting a new password, for example: "Check your inbox"',
  wb_forgotten_password_subtitle_tooltip:
    "Text below the heading of the password change window. Explain to the customer that after entering their email they will get a link to set a new password.",
  wb_forgotten_password_title_tooltip:
    'Heading of the window where the customer asks to change their password. Keep it short, for example: "Forgot your password?"',
  wb_form_tooltip:
    "Set up the fields of the contact form, for example a message field, an email address or an attachment. Everything the customer fills in comes to you by email.",
  wb_form_position_tooltip:
    'Choose which side of the section the form sits on: left or right. On a phone the same option decides the order: "left" shows the form above the content, "right" below it.',
  wb_gallery_distance_tooltip:
    "The gap between photos in the gallery, in pixels. A sensible range is 0 to 50. The bigger the gap, the narrower the photos become.",
  wb_gallery_height_tooltip:
    "The height of the gallery in pixels, for example 200 is a low strip and 500 is a large gallery. All photos will be fitted to this height.",
  wb_gallery_image_number_tooltip:
    "How many photos are visible side by side on a computer before the gallery scrolls on. Usually 1 to 4 works well.",
  wb_gallery_mobile_image_number_tooltip:
    "How many photos are visible side by side on a phone. On a small screen it is best to leave 1, at most 2.",
  wb_gallery_style_tooltip:
    "How the gallery controls look. Style 1 puts the arrows and dots on the photos, style 2 places them under the gallery, style 3 works like 1 but without the dark bar under the dots.",
  wb_gallery_width_tooltip:
    "How much of the section width the gallery takes up on a computer. Enter a percentage from 10 to 100, for example 50 is half the width. On phones the gallery always takes the full width.",
  wb_gdpr_fields_tooltip:
    "Add the consents a customer ticks when creating an account, for example a marketing consent. You can mark each one as required. We save the wording of the consent and the customer's decision with their account.",
  wb_google_tag_id_tooltip:
    "The ID of your Google Tag Manager container, for example GTM-XXXXXX. Once you enter it, you can collect visit statistics and connect Google tools.",
  wb_height_tooltip:
    "The height of the section in pixels, for example 400 is a low section and 700 is a section filling most of the screen. When there is more content, the section grows on its own.",
  wb_hide_arrows_tooltip:
    "Hides the arrows for scrolling the gallery. Turn it on when the photos should change only automatically.",
  wb_hide_booking_time_to_tooltip:
    "The customer sees only the start time of the appointment, without the end time and the duration. Useful when the actual length of the service sometimes differs from the one set in the system.",
  wb_hide_delimiters_tooltip:
    "Hides the dots under the gallery that let you jump to a chosen photo. The gallery then looks cleaner.",
  wb_hide_footer_tooltip:
    "Hides the footer at the bottom of all subpages, along with the contact details and the social media icons.",
  wb_hide_header_tooltip:
    "Hides the top bar with the logo and the menu on all subpages. Useful when you embed the page in another website.",
  wb_hide_login_tooltip:
    "Turns off signing in across the whole website. The customer will not see any sign in buttons or the sections available after logging in, and gets everything done without a customer account.",
  wb_hide_signup_tooltip:
    "Turns off creating new customer accounts. Customers who already have an account can still sign in, but nobody new can register.",
  wb_html_code_tooltip:
    "Your own HTML code shown as the content of this section. Use it when the ready-made sections are not enough and you want to add something of your own.",
  wb_image_contain_tooltip:
    "Shows the whole photo without cropping, even if empty margins are left beside it. Turned off: the photo fills the whole frame, but its edges may get cut off.",
  wb_image_height_tooltip:
    "The height of the photo in pixels, for example 200. The photo will be fitted to this height.",
  wb_image_hide_tooltip:
    "Turns off the photo in this section on all devices. The content takes up the freed space.",
  wb_image_hide_on_mobile_tooltip:
    "Hides the photo on phones only, so it does not take up space on a small screen. On a computer the photo stays.",
  wb_image_margin_bottom_tooltip:
    "The empty gap under the photo, in pixels. A sensible range is 0 to 50. A higher value pushes the text further from the photo.",
  wb_image_position_tooltip:
    "Where the photo sits in relation to the section content: on the left, on the right or in the center, at the top or at the bottom.",
  wb_image_rounded_tooltip:
    "How rounded the corners of the photo are: from sharp corners, through a slight rounding, to a full circle. A circle looks good on photos of people.",
  wb_image_to_right_tooltip:
    "Moves the photo to the right of the text. Visible on computers; on phones the photo and the text are always placed one under the other.",
  wb_image_width_tooltip:
    "The width of the photo in pixels, up to 1200. On phones the photo always fills the full width of the screen.",
  wb_image_zoom_on_click_tooltip:
    "After a click, a photo from the gallery opens enlarged on the full screen. The customer can look at the details.",
  wb_init_calendar_title_tooltip:
    'The heading of the screen where the customer picks a service, for example "What would you like to book?". It disappears once the customer picks a service.',
  wb_initial_location_select_tooltip:
    "The location field is filled in right away with the first available location, and the customer can change it. When this is off, the customer has to pick a location before seeing available times.",
  wb_initial_service_selection_tooltip:
    "Before the calendar, the customer picks a service on a separate screen, with the list grouped into categories. With a single service without variants, that screen does not appear.",
  wb_instagram_tooltip:
    "A link to your Instagram profile. Once you enter it, an Instagram icon appears on the page and leads to your profile.",
  wb_interval_tooltip:
    "How often the gallery changes the photo on its own, in milliseconds. 1000 is one second; 4000 to 8000 usually works well. Requires the “Automatic switching” option to be turned on.",
  wb_interval_minutes_tooltip:
    "How often the weekly calendar draws the next row with times, for example every 15 or every 30 minutes. A smaller value means a denser grid and a more detailed view of the day.",
  wb_invert_colors_tooltip:
    "Swaps the colors in this section: the first background becomes the second, and the text color adjusts to match. This way the section stands out from the ones next to it.",
  wb_latitude_tooltip:
    "The first of the two numbers that point to a place on the map, for example 52.2297. Open Google Maps, right-click your location, and at the very top of the menu you will see both numbers; clicking them copies them to the clipboard. Enter the first one here, with a dot instead of a comma.",
  wb_linkedin_tooltip:
    "A link to your LinkedIn profile. Once you enter it, a LinkedIn icon appears on the page and leads to your profile.",
  wb_location_search_tooltip:
    "A search field for looking up locations by name appears above the list. The customer sees it only when there are at least five locations on the list.",
  wb_login_modal_tooltip:
    "Settings for the window where the customer signs in to their customer account. Here you change the texts shown in that window.",
  wb_login_subtitle_tooltip:
    "A short text the customer sees at the top of the sign in window, right below the title. You can use it to welcome the customer or to explain what the account is for.",
  wb_longitude_tooltip:
    "The second of the numbers copied from Google Maps, for example 21.0122, the one after the comma. Enter it with a dot instead of a comma.",
  wb_main_pages_number_tooltip:
    "Set how many pages show in the top menu as separate buttons. The customer finds the remaining pages in the drop-down list next to them.",
  wb_map_maker_hide_tooltip:
    "Hides the red pin that marks your location. The map still shows, just without the place marked.",
  wb_menu_column_1_tooltip:
    "Pages shown in the first column of links in the footer. The customer gets to them with one click.",
  wb_menu_column_2_tooltip:
    "Pages shown in the second column of links in the footer, next to the first one.",
  wb_menu_title_tooltip:
    'Heading above the list of links in the footer, for example "Quick links" or "Menu". The customer sees it above the first column of pages.',
  wb_more_pages_button_tooltip:
    "The label on the button that expands the extra pages in the top menu when not all of them fit as separate tabs.",
  wb_newsletter_input_placeholder_tooltip:
    'The text shown in the empty email field in the newsletter section, for example "Your email address". It tells the customer what to type in.',
  wb_newsletter_success_message_tooltip:
    'This message appears on the page when a customer signs up for the newsletter, for example "Check your inbox and confirm the sign-up". The customer then gets an email with a confirmation link.',
  wb_only_services_with_subscriptions_tooltip:
    "The customer sees only the services from their active subscription. Note: without a subscription and after logging out, the list is empty.",
  wb_page_list_tooltip:
    "Choose which pages appear as menu items. The customer sees them in the order you set here.",
  wb_primary_language_tooltip:
    "The language in which customers see your page, for example the buttons, the forms and the booking view.",
  wb_privacy_policy_page_tooltip:
    "Point to the page with your privacy policy. The customer opens it by clicking the link in the note shown when creating an account.",
  wb_redirect_after_login_tooltip:
    "Choose the page the customer lands on right after signing in, for example the page for booking an appointment.",
  wb_redirect_after_signup_tooltip:
    "Choose the page the customer lands on right after creating an account, for example the page for booking an appointment.",
  wb_redirect_logo_tooltip:
    "Choose the page that opens when someone clicks the logo in the top menu. Usually it is the home page.",
  wb_regulations_page_tooltip:
    "Point to the page with your terms. The customer opens it by clicking the link in the note about accepting the terms when creating an account.",
  wb_require_billing_data_tooltip:
    "The customer has to give billing details to finish the booking. This works only when you have billing details turned on in the form.",
  wb_require_phone_number_tooltip:
    "The customer cannot finish the booking without giving a phone number. This works only when the phone field is visible in the form.",
  wb_section_text_tooltip:
    "Text shown in the section with the form. Use it to explain to the customer what the form is for and what happens after they send it.",
  wb_select_date_hour_tooltip:
    'Your own text shown above the calendar with the available times, for example "Pick a time that suits you".',
  wb_select_date_title_label_tooltip:
    'The heading above the calendar in the step where the customer picks the day and time of the appointment, for example "Choose a time".',
  wb_select_employees_title_label_tooltip:
    'The heading above the list of employees in the step where the customer picks a person, for example "Who would you like to book with?".',
  wb_select_locations_title_label_tooltip:
    'The heading above the list of locations in the step where the customer picks the place of the appointment, for example "Where would you like to book?".',
  wb_select_services_title_label_tooltip:
    'The heading above the list of services in the step where the customer picks a service, for example "Choose a service".',
  wb_selected_services_tooltip:
    'The heading above the list of times the customer added to the cart, for example "Your selected appointments". Visible only when the booking cart is on.',
  wb_selection_order_tooltip:
    "You decide the order in which the customer goes through the booking steps: service, location, employee. With several locations, it is worth starting with them.",
  wb_separate_online_locations_tooltip:
    'The customer picks a specific app: Google Meet, Zoom, Teams or WhatsApp. Without this option, they see a single "online" entry for all remote meetings.',
  wb_service_label_tooltip:
    'Your own label for the drop-down list where the customer picks a service, for example "Consultation" or "Type of appointment".',
  wb_service_list_tooltip:
    "Leave it empty and the section shows all your services, including the ones you add later. Once you pick specific services, every new one has to be added here.",
  wb_service_search_tooltip:
    "A search field for looking up services by name appears above the list. The customer sees it only when there are at least five services on the list.",
  wb_show_active_button_tooltip:
    "Highlights in the top menu the name of the page the customer is currently on, so it is easier for them to find their way.",
  wb_show_billing_data_tooltip:
    "The customer sees an option in the form to give billing details, as a company or as a private person. They decide whether to fill them in, unless you also set them as required.",
  wb_show_booked_slots_tooltip:
    "Booked times stay visible in the calendar, crossed out and impossible to click. The customer then sees that a given day is busy, instead of an empty list of times.",
  wb_show_company_name_tooltip:
    "Decide whether your company name shows next to the logo in the top bar. Turn it off if the logo alone is enough.",
  wb_show_expand_collapse_button_tooltip:
    "When a day has many free times, the customer sees only the first six and a button to expand the rest. This keeps the list shorter and easier to read.",
  wb_show_name_surname_tooltip:
    "When you turn this on, the customer gives their first and last name when booking. When you turn it off, the fields disappear and an email address is enough.",
  wb_show_phone_number_tooltip:
    "When you turn this on, a phone number field appears in the booking form. Useful if you call your customers or send them text messages.",
  wb_show_remind_password_link_tooltip:
    "When turned on, the customer sees a password reminder link on the sign in page. Clicking it opens a window where they enter their email and get a link to a new password.",
  wb_show_service_column_tooltip:
    "Next to the calendar, the customer sees a panel with a summary of the chosen service: name, price and duration. When this is off, only the calendar with the times is left.",
  wb_show_service_description_tooltip:
    'Under the chosen service, the customer sees its description from the Calendesk panel. Longer descriptions are shortened, and the customer expands the full text with the "Show more" link.',
  wb_show_sign_in_button_tooltip:
    "Shows a button in the top menu that the customer uses to open the sign in window for their customer account. Only people who are not logged in see it.",
  wb_show_sign_up_button_tooltip:
    "Shows a button in the top menu that the customer uses to open the window for creating a customer account. Only people who are not logged in see it.",
  wb_sign_in_button_tooltip:
    "The text and the look of the sign in button in the top menu. Here you change things like the button label and its style.",
  wb_sign_up_button_tooltip:
    "The text and the look of the account creation button in the top menu. Here you change things like the button label and its style.",
  wb_sign_up_modal_tooltip:
    "Settings for the window where the customer creates a customer account. Here you turn on things like the note about the terms and the invoice details.",
  wb_sign_up_terms_info_tooltip:
    "During registration the customer sees a note that by creating an account they accept the terms and the privacy policy. Point to both pages below, otherwise the links in that note will not work.",
  wb_start_calendar_time_tooltip:
    "The first hour visible in the weekly calendar on your page. Earlier hours are not shown, set it to the start of your working day.",
  wb_subtitle_tooltip:
    "A short line under the section title. A good place for one sentence that expands on the heading.",
  wb_summary_headline_tooltip:
    'The heading of the window the customer sees right after a successful booking, for example "Thank you for your booking!".',
  wb_summary_text_tooltip:
    "The text in the booking confirmation window, under the heading. Tell the customer what happens next, for example that they will get a confirmation email.",
  wb_text_tooltip:
    "The main text of this section. You can format it, for example make it bold or add lists.",
  wb_text_hide_tooltip:
    "Hides the text shown next to the form. The form then takes up more space.",
  wb_text_margin_bottom_tooltip:
    "The empty gap under the review text, in pixels. A sensible range is 0 to 50.",
  wb_tiktok_tooltip:
    "A link to your TikTok profile. Once you enter it, a TikTok icon appears on the page and leads to your profile.",
  wb_title_tooltip:
    "The main heading of this section. Your customer sees it as large text at the top of the section.",
  wb_twitter_tooltip:
    "A link to your profile on X (formerly Twitter). Once you enter it, an X icon appears on the page and leads to your profile.",
  wb_use_booking_cart_tooltip:
    "The customer can add several times to the cart, also for different services, and book them all at once with a single confirmation. Without the cart, each appointment is booked separately.",
  wb_view_flat_tooltip:
    "Removes the shadow from the booking boxes, so they look flat and minimal. Turned off: the boxes have a subtle shadow.",
  wb_view_rounded_tooltip:
    "How rounded the corners of the booking boxes and the calendar are: from sharp corners to a strong rounding.",
  wb_website_description_tooltip:
    "A description of your page for search engines such as Google. The customer sees it under the page name in search results and when a link is shared, but not on the page itself.",
  wb_youtube_tooltip:
    "A link to your YouTube channel. Once you enter it, a YouTube icon appears on the page and leads to the channel.",
  wb_zoom_tooltip:
    "How close the map is zoomed in, on a scale from 1 to 20. A value of 12 shows a whole city, 16 shows a street and its surroundings.",
  custom_duration_value: "Custom…",
  payment_authentication_failed_error:
    "Your bank did not confirm the payment. Try again and finish the confirmation in your banking app. If it keeps failing, use a different card or chat with us.",
  insufficient_funds_error:
    "Your card doesn't have enough funds, so the bank declined the payment. Top up the account or use another card and try again.",
  card_declined_error:
    "Your bank declined the payment with this card. Use another card or ask your bank why. If you need help, message us on the chat.",
  wb_auto_save_short: "Autosave",
  wb_save_status_saving: "Saving...",
  wb_save_status_saved_at: "Saved at @{time}",
  wb_save_status_error: "Saving failed",
  wb_save_retry: "Retry",
  wb_change_history: "Change history",
  wb_step_generic: "Settings change",
  wb_step_moved_section: "Section moved",
  wb_step_added_section: "Section added",
  wb_step_added_page: "Page added",
  wb_step_updated_page: "Page updated",
  wb_booking_dynamic_form: "Booking form fields",
  wb_form: "Form fields",
  wb_buttons: "Buttons",
  wb_buttons_position: "Buttons position",
  wb_form_position: "Form position",
  wb_image_position: "Position of the pictures",
  hide_client_facing_ids_checkbox:
    "Hide booking and transaction ID numbers from clients",
  hide_client_facing_ids_tooltip:
    "<b>Which numbers are hidden?</b><br>Booking, subscription, purchased product, transaction and payment numbers.<br><br><b>Where won't clients see them?</b><br>• in the booking confirmation on the website<br>• in the client panel: bookings, payments, subscriptions<br>• in default email notifications<br>• on the Stripe payment page<br>• in invoice line names (the invoice number itself stays)<br><br>You always see all numbers in the admin panel. If you add the booking number to your own notification template, it will still work.",
  variable_employee_title: "Employee position",
  employee_example_title: "Senior specialist",
  news: "News",
  no_news_yet: "No news yet",
  mark_all_news_as_read: "Mark all as read",
  news_read_more: "Read more",
  menu: "Menu",
  news_unread_tooltip: "News - unread: @{amount}",
  news_intro_title: "New: system news",
  news_intro_text:
    "From now on, every Calendesk change and announcement lives under this bell.",
  spotlight_got_it: "Got it",
  mobile_menu_intro_title: "New: bottom menu",
  mobile_menu_intro_text:
    "The menu, calendar, new bookings, sales and clients now live in the bottom bar.",
  merge_clients_title: "Merge clients",
  merge_clients_single_title: "Merge with another client",
  merge_clients_target_label: "Account to keep",
  merge_clients_add_client: "Add a client to merge",
  merge_clients_account_summary: "Bookings: @{bookings}",
  merge_clients_warning:
    "The other accounts will be deleted and their e-mail addresses will no longer log in. All bookings and notification history will move to the account you keep. The client will not get any message. Notes from the cards will be combined. Empty fields on the account you keep will be filled from the other accounts, and anything that can't be moved will be added to the note. This cannot be undone.",
  merge_clients_refusal_has_payments:
    "This account has payments or subscriptions and cannot be merged.",
  merge_clients_refusal_not_client:
    "This is a staff account and cannot be merged.",
  merge_clients_success: "Clients merged.",
  merge_clients_selection_hint: "Select 2 to 5 client accounts.",
  merge_clients_confirm: "Merge",
  max_user_bookings_period: "In what period?",
  max_user_bookings_period_info:
    "Example: a limit of 1 with a 30-day period means a customer can book this service again no earlier than 30 days after their previous visit. The visit date counts, not the day the booking is made. Your clients' booking page blocks bookings over the limit. In the admin panel and the employee mobile app you can add bookings over the limit, you'll just see a warning.",
  booking_limit_dialog_title: "Booking limit reached",
  booking_limit_dialog_message:
    "Booking limit for this service: @{max} per customer. The limit has already been reached. Do you want to create the booking anyway?",
  booking_limit_dialog_message_period:
    "Booking limit for this service: @{max} per customer within @{period}. The limit has already been reached. Do you want to create the booking anyway?",
  logs_diff_max_user_bookings_period: "Maximum user bookings period",
  "account_email-change": "Email address change - confirmation",
  "account_email-change_info":
    "Message with a confirmation link, sent to the new address when a client changes their email. The change takes effect only after the link is clicked.",
  "account_email-change_email_subject_client":
    "Confirm your new email address at [COMPANY_NAME]",
  "account_email-change_email_text_client":
    "<h1>Confirm your new email address</h1><p>We received a request to change the email address of your [COMPANY_NAME] account to [NEW_EMAIL]. Click below to confirm the new address. The change takes effect only after you confirm it. If this was not you, ignore this message.</p>",
  "account_email-change_email_cta_button_client": "Confirm new address",
  "account_email-changed": "Email address change - notification",
  "account_email-changed_info":
    "Information message sent to the previous address after a confirmed email change.",
  "account_email-changed_email_subject_client":
    "The email address of your [COMPANY_NAME] account has been changed",
  "account_email-changed_email_text_client":
    "<h1>Email address changed</h1><p>The email address of your [COMPANY_NAME] account has been changed to [NEW_EMAIL]. If this was not you, contact us right away.</p>",
  variable_new_email: "New email address",
  email_change_pending_banner:
    "Your email address change is waiting for confirmation. We sent a link to @{email}. Until you click it, the account keeps the current address.",
  email_change_pending_sent_info:
    "We sent a confirmation link to @{email}. The email address will change after you click it.",
  email_change_cancel_button: "Cancel change",
  email_change_resend_success: "The link has been sent again.",
  email_change_resend_too_soon:
    "We sent the link a moment ago. Wait a few seconds and try again.",
  email_change_cancel_success: "The email address change has been cancelled.",
  email_change_confirm_success:
    "Your email address has been changed. Log in with the new address.",
  email_change_confirm_error:
    "The confirmation link has expired or is invalid. Log in and send it again from your profile settings.",
  account_activation_completed:
    "Your account is active. Log in to get started.",
  email_change_confirm_taken_error:
    "This email address is already used by another account. Log in and start the change again with a different address.",
  email_change_no_pending:
    "There is no email address change waiting for confirmation.",
  notification_category_14: "Email address change",
  wb_employee_selection_mode: "Employee selection during booking",
  wb_employee_selection_mode_any_person_first:
    'Customer picks a person, "any person" is on the list',
  wb_employee_selection_mode_specific_only: "Customer picks a specific person",
  wb_employee_selection_mode_auto_assign:
    "Skip the selection step, assign automatically",
  wb_employee_selection_mode_tooltip:
    'Decides how the employee step works. "Customer picks a person" shows the list with "any person" as the first option. "Customer picks a specific person" hides the "any person" option, so the customer has to choose someone from the list. "Skip the selection step" fills the step in with "any person" and takes the customer straight to picking a time; the "Change" button still lets them pick a specific person.',
  customer_captcha_enabled_checkbox:
    "Protect booking, sign-up and login forms with Google reCAPTCHA",
  customer_captcha_enabled_tooltip:
    "<b>What does it do?</b><br>Google reCAPTCHA runs invisibly and stops bots from flooding your calendar with fake bookings or guessing your clients' passwords. Your clients don't click anything.<br><br><b>What happens when you turn it off?</b><br>Your booking page stops loading Google scripts and sets no Google cookies, which is easier to declare in a cookie policy. In return your forms lose the bot filter. If you turn it off, turn on the e-mail confirmation for bookings above, so anyone booking without an account has to confirm their address.",
  wb_cookie_banner_enabled: "Show a cookie banner on the website",
  wb_cookie_banner_enabled_tooltip:
    "Visitors decide whether they agree to statistics and ads. Until they do, Google Tag Manager and your custom code wait, and only what the site needs to work (login, bookings, payments, form protection) runs. Every text of the banner can be edited below.",
  wb_cookie_banner_edit_texts: "Cookie banner settings",
  wb_google_tag_mode: "Google Tag Manager runs",
  wb_google_tag_mode_tooltip:
    'Pick "Right away" only if you have set in your Google Tag Manager account which tags require consent. Otherwise the container waits until the visitor accepts statistics or ads.',
  wb_google_tag_mode_after_consent: "After the visitor agrees to cookies",
  wb_google_tag_mode_immediately:
    "Right away, passing the visitor's choice to Google",
  wb_custom_code_mode: "The code below runs",
  wb_custom_code_mode_tooltip:
    'One snippet can wait for a different consent than the rest. Add data-category="analytics", "marketing" or "functionality" to it and it watches only that one consent, for example <script data-category="marketing" src="...">. Works in script, link and style. Meta always runs.',
  wb_custom_code_mode_always: "Right away, without asking for consent",
  wb_custom_code_mode_functionality: "After consent to extra features",
  wb_custom_code_mode_analytics: "After consent to statistics",
  wb_custom_code_mode_marketing: "After consent to ads",
  wb_custom_code_blocked_info:
    "Snippets without their own category: @{count}. All of them wait for consent, so check that no font, style or chat is among them.",
  wb_custom_code_mode_hint_always:
    "This code runs for every visitor, also when they reject cookies. Keep it here only for code that tracks nobody.",
  wb_custom_code_mode_hint_consent:
    'When a visitor rejects cookies, this code does not run. To keep one snippet running anyway, add data-category="necessary" to it:\n<script ... data-category="necessary">',
  wb_cookie_banner_title: "Banner title",
  wb_cookie_banner_description: "Banner text",
  wb_cookie_banner_accept_all_button: '"Accept all" button',
  wb_cookie_banner_reject_all_button: '"Reject all" button',
  wb_cookie_banner_settings_button: '"Settings" button',
  wb_cookie_banner_privacy_policy_page: "Privacy policy page",
  wb_cookie_banner_privacy_policy_url: "Privacy policy address",
  wb_cookie_banner_privacy_policy_url_tooltip:
    "A link to a privacy policy outside this website. When filled in, it is used instead of the page above.",
  wb_cookie_banner_privacy_policy_link: "Privacy policy link text",
  wb_cookie_banner_block_page: "Block the page until the visitor decides",
  wb_cookie_banner_block_page_tooltip:
    "Off by default: visitors can book before they answer the banner.",
  wb_cookie_banner_preferences_title: "Settings window title",
  wb_cookie_banner_save_button: '"Save" button',
  wb_cookie_banner_necessary_title: "Necessary cookies, title",
  wb_cookie_banner_necessary_description: "Necessary cookies, description",
  wb_cookie_banner_functionality_title: "Extra features, title",
  wb_cookie_banner_functionality_description: "Extra features, description",
  wb_cookie_banner_analytics_title: "Statistics, title",
  wb_cookie_banner_analytics_description: "Statistics, description",
  wb_cookie_banner_marketing_title: "Ads, title",
  wb_cookie_banner_marketing_description: "Ads, description",
  wb_cookie_banner_default_title: "This website uses cookies",
  wb_cookie_banner_default_description:
    "Cookies are small files stored in your browser. Necessary cookies run login, bookings and payments and are always on. With your consent we also use cookies for visit statistics and to match ads to you. You can change or withdraw your consent at any time in the cookie settings.",
  wb_cookie_banner_default_accept_all_button: "Accept all",
  wb_cookie_banner_default_reject_all_button: "Reject all",
  wb_cookie_banner_default_settings_button: "Cookie settings",
  wb_cookie_banner_default_privacy_policy_link: "Privacy policy",
  wb_cookie_banner_default_preferences_title: "Privacy settings",
  wb_cookie_banner_default_save_button: "Save my choices",
  wb_cookie_banner_default_necessary_title: "Necessary",
  wb_cookie_banner_default_necessary_description:
    "These cookies are required for the site to work and cannot be switched off. They are set in response to your actions, such as logging in, making a booking, paying (Stripe) or sending a form (reCAPTCHA protection). You can block them in your browser, but parts of the site will then stop working. They do not store data that identifies you.",
  wb_cookie_banner_default_functionality_title: "Extra features",
  wb_cookie_banner_default_functionality_description:
    "These cookies add extra features to the site, such as a chat, a map or embedded videos. They may be set by the providers of those services. Without your consent these features may not work or may work in a limited way.",
  wb_cookie_banner_default_analytics_title: "Statistics",
  wb_cookie_banner_default_analytics_description:
    "These cookies count visits and traffic sources so we can measure and improve how the site works, for example with Google Analytics. They show which pages are visited most and how visitors move around the site. The data is aggregated and anonymous. Without your consent your visit is not counted in the statistics.",
  wb_cookie_banner_default_marketing_title: "Ads",
  wb_cookie_banner_default_marketing_description:
    "These cookies are set by advertising partners, for example Google Ads or Meta. They build a profile of your interests and show you matching ads on other sites. They do not store personal data directly, but they recognise your browser and device. Without your consent the ads you see will be less relevant.",
  wb_cookie_banner_enabled_info:
    "The banner is on. Its texts, categories, privacy link and the way back to the settings are in the button below, or click the banner in the preview. Settings that depend on the banner are marked with a coloured bar.",
  wb_cookie_banner_preview_edit: "Click to open the cookie banner settings",
  wb_section_preview_edit: "Click to open the section settings",
  wb_navbar_preview_edit: "Click to open the header settings",
  wb_footer_preview_edit: "Click to open the footer settings",
  wb_cookie_banner_section_bar: "Cookie bar",
  wb_cookie_banner_section_link: "Privacy policy link",
  wb_cookie_banner_section_preferences: "Settings window",
  wb_cookie_banner_privacy_policy_target: "Where does the link lead?",
  wb_cookie_banner_privacy_policy_target_none: "No link",
  wb_cookie_banner_privacy_policy_target_page: "A page of this website",
  wb_cookie_banner_privacy_policy_target_url: "An external address",
  wb_cookie_banner_default_preferences_description:
    "While you use this site, your browser may store or read information, usually as cookies. It can concern you, your preferences or your device, and it usually does not identify you directly. Below you choose which kinds of cookies you agree to. Blocking some of them may limit parts of the site.",
  wb_cookie_banner_preferences_description: "Settings window, intro text",
  wb_cookie_banner_categories: "Categories the visitor can choose",
  wb_cookie_banner_categories_tooltip:
    'Untick a category to hide it from the settings window. A hidden category is never accepted, so code assigned to it never runs. Google Tag Manager in the "after consent" mode starts only when statistics or ads are accepted, so keep at least one of them if you use it.',
  wb_cookie_banner_category_hidden: "hidden",
  wb_cookie_banner_reopen:
    "How does a visitor get back to the cookie settings?",
  wb_cookie_banner_reopen_icon: "A small cookie icon in the corner of the page",
  wb_cookie_banner_reopen_link: "A link I add myself (menu, footer or button)",
  wb_cookie_banner_reopen_both: "Both: the icon and my own link",
  wb_cookie_banner_reopen_link_info:
    "The icon is always visible, so the visitor can change their mind at any time without you doing anything. If you prefer a link in the footer or menu, add a menu entry or a redirect page and use this address:",
  wb_cookie_banner_reopen_link_missing:
    "Nothing on your site links to the cookie settings yet. Add a menu entry, footer link or button with the address above, otherwise visitors have no way to change their mind.",
  wb_cookie_banner_reopen_tooltip:
    "The visitor can change or withdraw consent at any time. Pick the icon, a link you place yourself (for example in the footer, the way most websites do it), or both.",
  employee_no_panel_access: "No panel access",
  guest_retention_days_label: "Delete the data after how many days?",
  guest_retention_anchor_label: "Count the days from when?",
  guest_retention_anchor_last_booking:
    "from this person’s last booking (recommended)",
  guest_retention_anchor_record_created: "from this person’s first booking",
  client_password_min_length_label: "Minimum password length",
  client_password_classes_label: "Required character types",
  client_password_class_upper: "Upper-case letter",
  client_password_class_lower: "Lower-case letter",
  client_password_class_digit: "Digit",
  client_password_class_special: "Special character",
  client_password_breach_check_checkbox:
    "Reject passwords known from data breaches",
  client_password_breach_check_tooltip:
    "We check whether the password has appeared in public data breaches. Only a fragment of the password's hash reaches the checking service, never the password itself or the e-mail address. If the service does not answer, the password passes without this check.",
  client_password_email_similarity_checkbox:
    'The password must not contain the part of the e-mail address before "@"',
  client_password_email_similarity_tooltip:
    'We check the part of the address before "@", ignoring letter case. For <b>anna.kowalska@example.com</b> the password <b>Anna.Kowalska2024!</b> is rejected, while <b>Kowalska2024!</b> passes. When that part is shorter than 4 characters (e.g. <b>jk@</b>), the rule blocks nothing.',
  client_password_settings_tooltip:
    "The rules apply on the booking site and in the customer app. Your employees’ passwords don’t change.",
  settings_privacy: "Privacy",
  privacy_account_card_title: "What do customers see when they log in?",
  privacy_account_card_description:
    "Right now, a logged-in customer sees every booking made with their email address, including the ones from before they had an account.",
  privacy_account_switch:
    "Show customers only the bookings made since they created their account",
  privacy_account_warning:
    "Older bookings, payments and files stay in your panel but disappear from the customer’s account. Every new customer can log in only after clicking the link in their email. Customers who have an account but never confirmed their address will be asked to confirm it the next time they log in: clicking the link in the email or using “Forgot password” is enough. Anyone who booked without an account signs up, because “Forgot password” won’t send them anything. Staff aren’t affected.",
  privacy_account_example_caption:
    "Example: Anna booked without an account and created one later.",
  privacy_account_example_now: "Now",
  privacy_account_example_after: "With this on",
  privacy_account_example_booking_before: "March 3: booking without an account",
  privacy_account_example_signup: "May 10: Anna creates an account",
  privacy_account_example_booking_after: "October 2: booking from her account",
  privacy_account_example_hidden: "visible only in your panel",
  guest_retention_example_last_booking:
    "Example: someone books today without an account. If they don’t book again, we’ll delete their data on the night after @{date}, but never before their booking takes place.",
  guest_retention_example_record_created:
    "Example: someone books for the first time today without an account. We’ll delete their data on the night after @{date}, even if they book again in the meantime, but never before a booking takes place.",
  guest_retention_timeline_label: "How does deletion work?",
  guest_retention_timeline_booking: "Booking without an account",
  guest_retention_timeline_booking_last:
    "counted from this person’s last booking",
  guest_retention_timeline_booking_first:
    "counted from this person’s first booking",
  guest_retention_timeline_wait: "@{days} day passes|@{days} days pass",
  guest_retention_timeline_wait_detail: "with no upcoming booking left",
  guest_retention_timeline_delete: "We delete the person’s data overnight",
  guest_retention_timeline_delete_detail:
    "name, contact details, sent messages, files and reviews",
  guest_retention_timeline_kept: "The booking stays, without personal data",
  guest_retention_timeline_kept_detail:
    "service, employee and date, so your stats still add up",
  guest_retention_advanced_title: "Advanced settings",
  guest_retention_scope_checkbox:
    "Also remove the person’s data from old bookings made without an account, even if they created an account later",
  guest_retention_scope_hint:
    "Example: Anna booked on March 3 without an account and created one on May 10. After the set time, the March 3 booking stays in your panel without her data (just service, employee and date) and is no longer linked to her account. Her account and her bookings from May 10 on don’t change. Bookings with a payment are left alone.",
  guest_retention_scope_why:
    "Why? Someone else may have made that booking with her email address, and she can’t see it in her account, so there’s no reason to keep her data on it.",
  guest_retention_never_title: "Who do we never delete?",
  guest_retention_never_account: "Customers with an account",
  guest_retention_never_payment: "Customers with a payment",
  guest_retention_never_subscription: "Customers with a subscription",
  guest_retention_never_upcoming: "Customers with an upcoming booking",
  guest_retention_never_manual: "Customers you added in the panel",
  client_password_preview_title: "How do these rules work on examples?",
  client_password_preview_email:
    "For a customer with the address @{email}. Breaches are checked only when the customer sets a password.",
  client_password_preview_passes: "accepted",
  client_password_preview_too_short: "too short (at least @{min} characters)",
  client_password_preview_missing: "missing: @{what}",
  client_password_preview_has_email: "contains part of the email address",
  guest_retention_scope_table_label: "What this setting changes",
  guest_retention_scope_table_booking: "The March 3 booking",
  guest_retention_scope_table_unchecked: "Unticked",
  guest_retention_scope_table_checked: "Ticked",
  guest_retention_scope_table_account: "In Anna’s account",
  guest_retention_scope_table_panel: "In your panel",
  guest_retention_scope_table_hidden:
    "Not visible, because “Show customers only the bookings made since they created their account” is on",
  guest_retention_scope_table_kept: "Stays with Anna’s data, indefinitely",
  guest_retention_scope_table_removed: "After @{days} day it stays without her data: just service, employee and date|After @{days} days it stays without her data: just service, employee and date",
  guest_retention_scope_requires_account_history:
    "Only works when “Show customers only the bookings made since they created their account” is on in “What do customers see when they log in?”.",
  guest_retention_dpo_title: "Details for your data protection officer",
  guest_retention_dpo_details:
    "<b>What do we delete?</b> The person’s data (name, email, phone, address), the emails and text messages sent to them, activity log entries, attachments and reviews. Each booking keeps an entry without personal data: service, employee, date and status.<br><br><b>Who don’t we delete?</b> People with an account, an account request or at least one login. People with a payment, a subscription or an upcoming booking. Employees, customers added in the panel without a booking, and anyone whose data appeared before the option was first turned on.<br><br><b>Backups</b> Deleted data is gone from backups within 21 days.<br><br><b>Proof of deletion</b> The “Data deletions” list shows each run: date, people deleted, bookings stripped of personal data, people skipped (payment or upcoming booking) and errors. We store numbers only. For 90 days we keep an irreversible hash of deleted email addresses, so we can confirm on request whether an address was deleted. “Trial” means a run that deleted nothing.",
  privacy_retention_confirm_preview_bookings:
    "We’ll also remove personal data from @{bookings} old bookings of customers who created an account later.",
  client_password_extra_rules_title: "Extra rules",
  client_password_policy_empty:
    "We can’t save just the 8-character minimum with no other rule. Tick at least one character type, raise the minimum length or turn on one of the extra rules.",
  client_password_weaker_than_default:
    "These rules are looser than today’s: the booking site will accept passwords without the character types you unticked.",
  logs_diff_account_requested_at: "Account requested",
  logs_diff_account_requested_via: "Account requested via",
  account_request_via_signup_form: "sign-up on the site",
  account_request_via_booking_form: "booking form",
  account_request_via_store_form: "store",
  account_request_via_admin_panel: "panel (staff)",
  account_request_via_password_reset: "password reset",
  account_request_via_backfill: "account from before the change",
  account_status_account: "Account",
  account_status_pending: "Awaiting confirmation",
  account_status_guest: "No account",
  account_status_blocked: "Blocked",
  account_status_filter: "Account",
  account_status_account_details: "Account confirmed @{date}",
  account_status_pending_details:
    "Asked for an account @{date} (@{via}), address not confirmed yet",
  account_status_guest_details: "Books without an account",
  retention_forecast_kept: "We don’t delete this data: @{reason}.",
  retention_forecast_due_tonight: "We’ll delete the data tonight.",
  retention_forecast_due_after:
    "We’ll delete the data the night after @{date} at the earliest.",
  retention_forecast_due_after_booking:
    "We’ll delete the data the night after @{date} at the earliest, once the booking date has passed.",
  retention_forecast_reason_account: "the customer has an account",
  retention_forecast_reason_account_request:
    "the customer asked for an account",
  retention_forecast_reason_staff: "this is a staff member",
  retention_forecast_reason_before_enabled:
    "the data is from before deletion was switched on",
  retention_forecast_reason_logged_in: "the customer has logged in on the site",
  retention_forecast_reason_no_booking: "the customer has no bookings",
  retention_forecast_reason_managed_by_staff:
    "a booking for this customer was added by staff or an import",
  event_customer_removed: "Customer data deleted",
  retention_forecast_reason_payment: "the customer has a payment",
  retention_forecast_reason_subscription: "the customer has a subscription",
  privacy_account_confirm_warning:
    "Customers will only see bookings made since they created their account, and new customers can log in only after confirming their email. Anyone who booked without an account has to sign up. You still have every booking in your panel.",
  privacy_account_confirm_unconfirmed:
    "Customers with an account who will confirm their address the next time they log in: @{count}.",
  privacy_retention_card_title: "Deleting data of people without an account",
  privacy_retention_card_description:
    "Right now, the data of people who book without an account stays in the system for good.",
  privacy_retention_switch: "Delete this data automatically after a set time",
  privacy_retention_confirm_warning: "From now on, every night we’ll permanently delete the data of people without an account once @{days} day has passed. This can’t be undone.|From now on, every night we’ll permanently delete the data of people without an account once @{days} days have passed. This can’t be undone.",
  privacy_retention_confirm_reenable:
    "The option was already on from @{date}, so it also covers people who booked without an account while it was off.",
  privacy_password_card_title: "Customer passwords",
  privacy_password_card_description:
    "Right now, a customer password needs at least 8 characters, including a lowercase and an uppercase letter, a digit and a special character like ! or #.",
  privacy_password_switch: "Set your own password rules",
  privacy_confirm_title: "Save the privacy changes?",
  profile_account_details: "Account details",
  guest_retention_coverage_on_save:
    "Deletion only covers people whose data appears after you save. We don’t delete your current customers.",
  guest_retention_coverage_since:
    "We only delete people whose data appeared on or after @{date}. Customers from before that date are never deleted, even if you turn this off and on again.",
  guest_data_purges_title: "Data deletions",
  guest_data_purges_description:
    "Every nightly deletion is recorded here. You can download the list as CSV for your data protection officer.",
  guest_data_purges_after_save:
    "The list will appear once you save. We check the data every night, but the first people will be deleted no earlier than the night after @{date}.",
  guest_data_purges_status_none:
    "No runs yet. We check the data every night; the first people will be deleted no earlier than the night after @{date}.",
  guest_data_purges_status_last: "Last run: @{date}, @{users} people removed.",
  guest_data_purges_none: "No runs yet.",
  guest_data_purges_none_with_changes:
    "No run has removed anything yet. You'll find every run in the CSV file.",
  guest_data_purges_rest_in_csv:
    "The other runs didn't remove anything. You'll find every run in the CSV file.",
  guest_data_purges_show_more: "Show more",
  guest_data_purges_export: "Download CSV",
  guest_data_purges_dry_run: "trial (nothing deleted)",
  guest_data_purges_col_run: "Run",
  guest_data_purges_col_users: "People removed",
  guest_data_purges_col_bookings: "Bookings anonymised",
  guest_data_purges_col_excluded: "Skipped (payment or upcoming booking)",
  guest_data_purges_col_errors: "Errors",
  privacy_retention_confirm_preview:
    "Tonight we’ll delete the data of @{users} people without an account.",
  guest_data_purges_load_failed:
    "Could not load the deletions list. Your settings are saved; refresh the page to see the list.",
  guest_data_purges_export_failed:
    "Could not download the CSV file. Try again.",
  plan_preview_title: "What do you pay today?",
  plan_preview_subtotal: "Subtotal",
  plan_preview_discount: "Discount",
  plan_preview_tax: "VAT",
  plan_preview_credit_used: "From your balance",
  plan_preview_amount_due: "Due today",
  plan_preview_credit_after: "Left on your balance: {amount}",
  plan_preview_renews_at: "Next payment: {date}",
  plan_preview_no_change:
    "This is your current plan. Nothing changes and we won't charge you.",
  plan_preview_resume:
    "You're staying on your current plan and we'll call off the scheduled change. You won't be charged today.",
  plan_preview_credit_note:
    "The difference goes to your balance and covers your next payments.",
  plan_preview_credit_covers:
    "Your balance pays the next renewals of {amount}. Your card is charged next on {date}.",
  plan_preview_carried_to_next:
    "We'll add {amount} to your next payment. A card can't be charged for such a small amount.",
  plan_preview_applied_discount:
    "Your discount ({discount}) is already included in these prices.",
  plan_preview_loading: "Working out what you pay today…",
  plan_preview_discount_code: "Code {code}",
  plan_preview_discount_forever: "no end date",
  plan_preview_discount_until: "until {date}",
  plan_preview_discount_once: "first payment only",
  change_plan: "Change plan",
  plan_changes_adding: "Adding: {items}",
  plan_changes_removing: "Turning off: {items}",
  plan_changes_changing: "Changing: {items}",
  plan_changes_due_today: "You pay today: {amount}",
  max_gap_between_bookings_checkbox_text: "Limit the gap between an employee's bookings",
  max_gap_between_bookings: "Maximum gap",
  max_gap_between_bookings_info:
    "When the employee already has a booking that day, customers see online only the times within this many minutes of it (breaks before and after the service included). A day with no bookings shows every time from the schedule. A gap set on the employee takes precedence over this one. In the admin panel and the employee app you can add bookings without this limit.",
  logs_diff_max_gap_between_bookings: "Maximum gap between bookings",
  invoice_not_issued: "Invoice not issued",
  invoice_retry_queued: "Queued",
  invoice_retry_button: "Issue the invoice again",
  invoice_retry_confirm_title: "Issue the invoice again?",
  invoice_retry_confirm_warning:
    "We'll issue the invoice once more. The payment date becomes the sale date, and the customer gets it like any other invoice.",
  invoice_retry_queued_info:
    "The invoice is queued. Its status will refresh in a moment.",
  invoice_retry_skipped_already_issued: "This invoice has already been issued.",
  invoice_retry_skipped_in_progress:
    "This invoice is already waiting in the queue.",
  invoice_retry_skipped_not_eligible: "This payment can't be invoiced again.",
  invoice_retry_skipped_forbidden:
    "You don't have permission to issue this invoice.",
  event_bulk_count_bookings: "@{count} booking|@{count} bookings",
  event_bulk_count_blockades: "@{count} blackout date|@{count} blackout dates",
  event_bulk_delete_summary: "You will delete @{bookings} and @{blockades}.",
  event_bulk_delete_summary_bookings: "You will delete @{bookings}.",
  event_bulk_delete_summary_blockades: "You will delete @{blockades}.",
  event_deleting_bookings_title: "Deleting bookings",
  event_deleting_blockades_title: "Deleting blackout dates",
  event_bulk_status_summary: "@{count} booking will get the status \"@{status}\".|@{count} bookings will get the status \"@{status}\".",
  event_bulk_status_skipped_blockades: "We will skip @{blockades} because blackout dates have no status.",
  event_bulk_skipped_bookings_no_permission: "We will skip @{bookings} because you don't have permission for them.",
  event_bulk_skipped_blockades_no_permission: "We will skip @{blockades} because you don't have permission for them.",
  event_bulk_skipped_company_blockades: "We will skip @{blockades} for the whole company (no employee assigned) because you are filtering by employee.",
  event_bulk_no_filters_warning: "No filter is set, so this affects every event on the account.",
  event_bulk_over_limit_delete: "You can delete at most @{limit} events at once. Narrow the filters, for example to a shorter date range.",
  event_bulk_over_limit_update: "You can change the status of at most @{limit} bookings at once. Narrow the filters, for example to a shorter date range.",
  event_bulk_nothing_to_process: "There is nothing for this action to process.",
  panel_company_account_not_found:
    "We could not find this company account. It may have been deleted. Sign in again to continue.",
  bulk_operation_completed_with_skipped:
    "Completed. Processed: @{processed}, failed: @{failed}, skipped: @{skipped}. Skipped ones were already deleted or are outside your permissions.",
  employee_panel_access_title: "Access to the Calendesk panel",
  employee_public_profile_title: "Profile visible to customers",
  employee_advanced_settings_title: "Advanced settings",
  employee_max_gap_card_info:
    "The availability schedule still decides when this employee takes customers at all. The gap only applies on days when someone has already booked: the customer then sees slots close to existing bookings. On a day with no bookings they see every slot from the schedule. \"No limit\" switches the restriction off.",
  employee_max_gap_switch:
    "Custom gap for this employee",
  employee_max_gap_none: "No limit",
  employee_max_gap_title: "Maximum gap between bookings",
  max_gap_timeline_booking:
    "Booking",
  max_gap_timeline_open:
    "Free",
  max_gap_timeline_closed:
    "Hidden",
  max_gap_timeline_caption_limited:
    "The customer only sees slots within @{gap} of the booking. Slots further away are hidden, but only on days when someone has already booked. Working hours still come from the availability schedule.",
  max_gap_timeline_caption_unlimited:
    "With no limit, the customer sees every free slot from the schedule, whatever is already booked.",
  employee_services_section_title: "Services and availability schedule",
  employee_availability_scope_from_employee: "Slots from the employee's schedule",
  employee_availability_scope_own_schedule:
    "Slots from the service's schedule",
  employee_availability_scope_none_here: "None of the selected services",
  employee_availability_scope_caption:
    "When a service has its own schedule, customers see the slots of that schedule and the employee's schedule is ignored. For the other services, customers see the slots of the employee's availability schedule chosen above.",
  employee_availability_scope_not_public:
    "This employee doesn't take online bookings, so customers won't see their slots in any service.",
  employee_availability_scope_no_services:
    "Pick the services this employee performs. Without them, customers can't book with this person.",
  employee_availability_scope_no_schedule:
    "Without an availability schedule, customers won't see any free slots here.",
  employee_legacy_hours_warning:
    "This employee still uses the old work schedule. Move it to an availability schedule: you can assign the same schedule to other people and edit it in one place.",
  employee_legacy_hours_migrate: "Move to an availability schedule",
  employee_legacy_hours_migrated:
    "The hours move to a new schedule \"@{name}\" when you save the employee.",
  employee_legacy_schedule_name: "@{name} - work schedule",
  employee_public_preview_caption:
    "This is how customers see it. Depending on the booking calendar you use, a longer description either folds after @{limit} characters behind a \"Show more\" link or sits, together with the links, behind the arrow next to the name. The Team section of your website shows the whole description.",
  employee_public_preview_name_placeholder: "First and last name",
  employee_public_preview_description_placeholder:
    "The employee's description will show up here.",
  employee_send_set_password_link: "Send the employee a link to set a password",
  employee_send_set_password_link_hint:
    "The link goes to @{email} in the employee's language and works for 7 days.",
  employee_role_matrix_label: "Role comparison",
  employee_role_matrix_own_calendar: "Own calendar and bookings",
  employee_role_matrix_others_calendars: "Other employees' calendars",
  employee_role_matrix_customers: "Customer details",
  employee_role_matrix_booking_payments: "Booking payments",
  employee_role_matrix_team_services_website: "Employees, services and website",
  employee_role_matrix_account_settings: "Account settings",
  employee_role_matrix_plan_invoices: "Calendesk plan and invoices",
  employee_role_matrix_cell_yes: "Yes",
  employee_role_matrix_cell_no: "No",
  employee_role_matrix_cell_own: "Own only",
  employee_role_matrix_cell_view: "View only",
  employee_role_matrix_cell_booking_only: "Only when adding a booking",
  employee_role_matrix_cell_no_delete: "Yes, without deleting",
  employee_locale_time_zone_title: "Language and time zone",
  employee_locale_time_zone_info:
    "The language sets the panel and Calendesk's system emails to the employee, such as the set-password link. Booking notifications go out in the language of your templates. The time zone sets the hours in the employee's panel. Empty fields mean the account-wide settings.",
  employee_locale_time_zone_locked:
    "You can let employees set their own language and time zone in the platform settings.",
  employee_locale_time_zone_locked_link: "Go to settings",
  max_gap_timeline_badge: "Example",
  max_gap_timeline_title: "An example working day from the schedule, with one booking",
  max_gap_timeline_row_without: "Without a gap",
  max_gap_timeline_row_with: "With a @{gap} gap",
  max_gap_timeline_row_empty: "A day with no bookings",
  max_gap_timeline_start: "start of work",
  max_gap_timeline_end: "end of work",
  max_gap_timeline_caption_nothing_hidden:
    "In this example a @{gap} gap hides nothing, because the whole day falls within its reach.",
  max_gap_timeline_empty_note:
    "While nobody has booked yet, the gap changes nothing: the customer sees every slot from the schedule.",
  employee_max_gap_subtitle:
    "How far from an existing booking a customer can pick a slot.",
  employee_max_gap_switch_hint_off:
    "The gap set on each service applies for now.",
  employee_max_gap_switch_hint_on:
    "This gap applies to all of this employee's services and replaces the service settings.",
  employee_public_preview_show_more: "Show more",
  employee_public_preview_collapse: "Collapse",
  variable_booking_resources: "Booking resources",
  variable_booking_resources_block:
    "Booking resources, or a text when there are none",
  booking_resources_block_with: "Assigned resources: [BOOKING_RESOURCES]",
  booking_resources_block_without:
    "We'll assign resources before your booking.",
  resource_example_name: "Room A",
  booking_resources_preview_title: "Resources in the preview",
  booking_resources_preview_with: "With a resource",
  booking_resources_preview_without: "Without a resource",
  booking_resource_conflicts_dialog_title: "Resource conflict",
  booking_resource_conflicts_dialog_message:
    "At this time, the selected resources are already assigned to other bookings:",
  booking_resource_conflicts_dialog_question: "Save the booking anyway?",
  booking_resource_conflicts_other_employee: "Another employee's booking",
  booking_resource_conflicts_truncated: "Only some of the conflicts are shown.",
  booking_resources_day_preview_title:
    "Bookings with these resources on this day",
  booking_reminder_custom_content_button: "Edit text",
  booking_reminder_custom_content_chip: "Custom text",
  booking_reminder_use_default_content_information:
    "This reminder will send the text of the \"Booking reminder\" template again.",
  logs_subject_type_bookingresource: "Linking resource to booking",
  booking_resources_info:
    "Pick what you assign to this booking, such as an office or a hall. The client sees it in their booking details and gets a notification when it changes, if you send notifications.",
  booking_tags_info:
    "Only you and your team see labels, your clients don't. Use them to mark bookings and filter the booking list.",
  resource_type_resource: "Resource",
  resource_type_pool: "Pool",
  resource_group_usage_per_participant: "Each participant takes one place",
  resource_group_usage_per_slot: "The whole group takes one place",
  resource_assignment_manual_only: "Nobody, I'll assign it myself",
  resource_assignment_always: "All bookings",
  resource_assignment_by_rule: "Only selected bookings",
  resource_convert_to_pool: "Turn into a pool",
  resource_convert_to_pool_info:
    "Enter the position names. The quantity becomes their number.",
  resource_convert_to_resource: "Turn into a plain resource",
  resource_convert_to_resource_info:
    "We'll delete every position of this pool and remove them from bookings. This can't be undone.",
  booking_resources_group_locked:
    "The whole group has this position. Change it in the group booking.",
  booking_resources_group_single_date:
    "You can change the group's resources for this date only.",
  booking_resources_awaiting: "none yet, waiting to be assigned",
  booking_resources_awaiting_pool: "\"@{pool}\": waiting to be assigned",
  booking_resource_rule_mismatch_title_service: "This position isn't meant for this service",
  booking_resource_rule_mismatch_title_booking: "This position isn't meant for this booking",
  booking_resource_rule_only_services: "\"@{resource}\" (pool \"@{pool}\") is only for: @{services}.",
  booking_resource_rule_only_employees: "\"@{resource}\" (pool \"@{pool}\") is only for bookings with: @{employees}.",
  booking_resource_rule_services_with_employees: "\"@{resource}\" (pool \"@{pool}\") is only for: @{services}, and only with: @{employees}.",
  booking_resource_rule_services_or_employees: "\"@{resource}\" (pool \"@{pool}\") is only for: @{services}, or for bookings with: @{employees}.",
  booking_resource_rule_other: "\"@{resource}\" (pool \"@{pool}\") has an assignment rule that doesn't cover this booking.",
  booking_resource_rule_booking: "This booking is for: @{service}.",
  booking_resource_rule_booking_with_employee: "This booking is for: @{service}, with: @{employee}.",
  booking_resource_rule_mismatch_question_one: "Save the booking with this position anyway?",
  booking_resource_rule_mismatch_question_many: "Save the booking with these positions anyway?",
  booking_resource_suggestions_none: "There's no free position in the pool \"@{pool}\" at this time.",
  booking_resource_shortage_title: "No free resource at this time",
  booking_resource_shortage_title_pool: "No free position at this time",
  booking_resource_shortage_pool: "Every position of the pool \"@{pool}\" is taken at @{time} (@{used} of @{capacity}). If you save the booking, it won't get any position from this pool.",
  booking_resource_shortage_pool_rule: "The pool \"@{pool}\" has no free position for this booking at @{time}: its free positions are meant for other bookings. If you save the booking, it won't get any position from this pool.",
  booking_resource_shortage_resource: "The resource \"@{resource}\" is taken at @{time} (@{used} of @{capacity}).",
  booking_resource_suggestions_title: "Free and allowed at this time:",
  availability_schedule_resources_condition_info:
    "Only services using the chosen resources get these hours. Pick specific positions and a booking in these hours gets one of them.",
  resource_wizard_step_type: "What you add",
  resource_wizard_step_names: "Names",
  resource_wizard_step_quantity: "How many",
  resource_wizard_step_services: "Services",
  resource_wizard_step_group: "Group bookings",
  resource_wizard_step_assignment: "Assignment",
  resource_wizard_step_summary: "Review",
  resource_wizard_step_of: "Step @{step} of @{total}",
  resource_wizard_steps_label: "Wizard steps",
  resource_wizard_title_new_pool: "New pool \"@{name}\"",
  resource_wizard_title_new_resource: "New resource \"@{name}\"",
  resource_wizard_title_edit: "Edit \"@{name}\"",
  resource_wizard_title_add_position: "Add a position to \"@{name}\"",
  resource_wizard_type_title: "What do you want to add?",
  resource_wizard_type_subtitle: "Pick the one that fits how you work.",
  resource_wizard_type_resource_title: "Several identical things",
  resource_wizard_type_resource_info:
    "For example 2 rooms or 3 projectors. It doesn't matter which one a booking gets.",
  resource_wizard_type_pool_title: "Things with their own names",
  resource_wizard_type_pool_info:
    "For example offices 106, 107 and 108. Every booking gets one of them, and you see which.",
  resource_wizard_name_label: "What should we call it?",
  resource_wizard_name_hint_pool:
    "A name for the whole pool, e.g. \"Offices\".",
  resource_wizard_name_hint_resource: "E.g. \"Rooms\" or \"Projectors\".",
  resource_wizard_names_title: "What's in the pool \"@{name}\"?",
  resource_wizard_names_subtitle:
    "Enter the names you and your team will see. You need at least two different positions.",
  resource_wizard_position_name: "Name",
  resource_wizard_add_position: "Add position",
  resource_wizard_empty_rows_skipped: "Empty rows are skipped.",
  resource_wizard_removed_positions_info:
    "When you save, removed positions also come off the bookings they were assigned to. The bookings themselves stay.",
  resource_guide_title:
    "How do resources work?",
  resource_guide_intro:
    "A resource is something a booking needs and you only have so many of: an office, a room, equipment. Once all of it is taken, customers don't see that time as free.",
  resource_guide_resource_text:
    "You only count units. Three projectors means at most three bookings at the same time, without saying which projector.",
  resource_guide_pool_text:
    "Each unit has its own name, e.g. offices 106, 107 and 108. A booking gets a specific position, and you see it in the calendar and in the booking window.",
  resource_guide_assignment_title:
    "Who gets a position?",
  resource_guide_assignment_always:
    "Every booking of a service that uses the pool.",
  resource_guide_assignment_by_rule:
    "Only the people or services you choose, e.g. office 108 only for couples therapy.",
  resource_guide_assignment_manual_only:
    "The booking waits until you pick a position in the booking window. You'll find these bookings in the booking list under the \"Waiting for a resource\" filter.",
  resource_guide_schedules_title:
    "Resources in schedules",
  resource_guide_schedules_text:
    "In an availability schedule you can name a pool or specific positions. A booking in those hours gets one of them. A position you assign yourself opens no free times, so name positions that are assigned automatically.",
  resource_guide_groups_title:
    "Group classes",
  resource_guide_groups_text:
    "For each resource you choose whether every participant takes one place or the whole group takes one.",
  resource_delete_pool_info:
    "Deleting a pool also deletes its positions and takes them off the bookings they were assigned to. The bookings themselves stay.",
  delete_failed_for:
    "Deleted: @{deleted}. Couldn't delete: @{failed}",
  delete_failed_item: "\"@{name}\": @{reason}",
  resource_wizard_quantity_title: "How many \"@{name}\" do you have?",
  resource_wizard_quantity_subtitle:
    "That's how many bookings you can take at the same time.",
  resource_wizard_quantity_less: "Fewer",
  resource_wizard_quantity_more: "More",
  resource_wizard_services_title: "Which services use \"@{name}\"?",
  resource_wizard_services_subtitle_pool:
    "Every booking of a selected service takes one position from the pool. You can change this later in the service settings.",
  resource_wizard_services_subtitle_resource:
    "Every booking of a selected service takes one unit. You can change this later in the service settings.",
  resource_wizard_no_services:
    "You don't have any services yet. Once you add them, pick the resource in the service settings.",
  resource_wizard_services_online_note:
    "Online services usually don't need to be selected here.",
  resource_wizard_service_minutes: "@{minutes} min",
  resource_wizard_service_group: "group, up to @{max} people",
  resource_wizard_group_title:
    "@{service}: how much of \"@{name}\" does a group take?",
  resource_wizard_group_subtitle:
    "This is a group service, so we need to know.",
  resource_wizard_group_one_position: "one position of \"@{name}\"",
  resource_wizard_group_one_unit: "one unit of \"@{name}\"",
  resource_wizard_group_per_participant_info: "Each participant takes @{unit}.",
  resource_wizard_group_per_slot_info:
    "The whole group takes @{unit}, however many people join. The rest stay free for other bookings.",
  resource_wizard_assignment_title:
    "How should positions from \"@{name}\" be assigned?",
  resource_wizard_assignment_subtitle:
    "Every new booking automatically gets one free position. You can limit that here. If it doesn't matter which booking gets which position, leave everything as it is.",
  resource_wizard_assignment_question:
    "Who can the system give \"@{name}\" to?",
  resource_wizard_assignment_always_info:
    "The system can give this position to any booking of the selected services.",
  resource_wizard_assignment_by_rule_info:
    "You choose whose bookings and which services can get this position. Pick people, services or both. Other bookings get another position from the pool.",
  resource_wizard_assignment_manual_only_info:
    "The system never gives this position on its own; you assign it in the booking window. It still counts towards the limit: with @{positions} position, customers can book at most @{count} booking at the same time, even before you assign anything.|The system never gives this position on its own; you assign it in the booking window. It still counts towards the limit: with @{positions} positions, customers can book at most @{count} bookings at the same time, even before you assign anything.",
  resource_wizard_set_all_always: "Set \"All bookings\" everywhere",
  resource_wizard_rule_employees: "Whose bookings?",
  resource_wizard_rule_services: "Which services?",
  resource_wizard_rule_empty_means_all:
    "Leave a row empty to include everyone.",
  resource_wizard_rule_match_question:
    "You've picked people and services. Who can get this position?",
  resource_wizard_rule_match_all: "Both must match",
  resource_wizard_rule_match_all_example:
    "E.g. only \"@{service}\" when @{employee} runs it.",
  resource_wizard_rule_match_any: "Either is enough",
  resource_wizard_rule_match_any_example:
    "E.g. every booking with @{employee} and every \"@{service}\".",
  resource_wizard_rule_needs_services:
    "Select services in the \"Services\" step first.",
  resource_wizard_rule_pool_without_services:
    "This pool isn't used by any service yet.",
  resource_wizard_rule_advanced:
    "This position has a rule set through the API that can't be shown here. It stays as it is unless you replace it.",
  resource_wizard_rule_replace: "Replace with a simple choice",
  resource_wizard_rule_advanced_short: "rule from the API",
  resource_wizard_or: "or",
  resource_wizard_summary_title: "Review before you save",
  resource_wizard_summary_subtitle:
    "On the right: the same example day with your settings.",
  resource_wizard_summary_type: "Type",
  resource_wizard_summary_name: "Name",
  resource_wizard_summary_positions: "Positions",
  resource_wizard_summary_quantity: "Quantity",
  resource_wizard_summary_services: "Services",
  resource_wizard_summary_group: "Group bookings",
  resource_wizard_summary_assignment: "Assignment",
  resource_wizard_summary_no_services:
    "None yet, you can add them in a service later",
  resource_wizard_change: "Change",
  resource_wizard_create_pool: "Create pool",
  resource_wizard_create_resource: "Create resource",
  resource_wizard_count_positions: "@{count} position|@{count} positions",
  resource_wizard_count_units: "@{count} unit|@{count} units",
  resource_wizard_error_name_required: "Enter a name.",
  resource_wizard_error_name_too_long:
    "The name can have at most @{max} characters.",
  resource_wizard_error_name_characters:
    "The name can't contain square or curly brackets, < or >.",
  resource_wizard_error_duplicate: "This name is already on the list.",
  resource_wizard_error_two_names: "Enter at least two different names.",
  resource_wizard_error_too_many: "A pool can have at most 200 positions.",
  resource_wizard_error_quantity: "Enter a number from 1 to @{max}.",
  resource_wizard_error_rule_empty: "Pick at least one person or service.",
  resource_wizard_close_title: "Close without saving?",
  resource_wizard_close_warning:
    "The names and settings you entered won't be saved.",
  resource_wizard_close_keep: "Back to the wizard",
  resource_wizard_close_discard: "Close without saving",
  resource_wizard_pool_added: "Pool \"@{name}\" added.",
  resource_wizard_resource_added: "Resource \"@{name}\" added.",
  resource_wizard_saved: "Changes saved.",
  resource_wizard_in_practice: "What this means in practice",
  resource_wizard_example_always:
    "Any booking of a service that uses the pool \"@{pool}\" can get \"@{name}\" if nothing else is booked there at that time.",
  resource_wizard_example_manual:
    "The system never gives \"@{name}\" on its own. You assign it in the booking window.",
  resource_wizard_example_manual_counts:
    "A booking waiting for you to assign a position still takes a place in the pool. When every position is taken or waiting, customers won't see that time.",
  resource_wizard_example_fits:
    "@{service} with @{employee}: can get \"@{name}\" if nothing else is booked there at that time.",
  resource_wizard_example_misses:
    "@{service} with @{employee}: won't get \"@{name}\". The system gives another free position.",
  resource_wizard_preview_example_title: "With your own setup",
  resource_wizard_preview_type_name_first:
    "Enter a name on the left and we'll show how it looks on a booking.",
  resource_wizard_preview_label_title: "This is how it shows on a booking",
  resource_wizard_preview_label_caption:
    "In the booking window and in the calendar.",
  resource_wizard_preview_booking_resources: "Booking resources",
  resource_wizard_preview_label_pool_note:
    "\"…\" becomes the name of one position of the pool \"@{name}\". You'll enter them in the next step.",
  resource_wizard_preview_label_resource_note:
    "You'll set how many \"@{name}\" you have in the next step.",
  resource_wizard_preview_names_caption:
    "Every booking gets one of these positions. In the calendar and the booking window you see it together with the pool name.",
  resource_wizard_preview_names_examples: "Booking resources, examples",
  resource_wizard_preview_names_empty: "Enter the names on the left.",
  resource_wizard_preview_names_note:
    "@{positions} position means at most @{bookings} booking at the same time. You'll choose who gets it in the \"Assignment\" step.|@{positions} positions mean at most @{bookings} bookings at the same time. You'll choose who gets them in the \"Assignment\" step.",
  resource_wizard_preview_more_positions:
    "and @{count} more position|and @{count} more positions",
  resource_wizard_preview_quantity_title: "How many bookings at once?",
  resource_wizard_preview_quantity_caption:
    "That's how many bookings at the same time can use \"@{name}\".",
  resource_wizard_preview_quantity_at_once:
    "@{count} booking at once|@{count} bookings at once",
  resource_wizard_preview_quantity_note:
    "The calendar keeps showing that time as available until there is @{count} booking.|The calendar keeps showing that time as available until there are @{count} bookings.",
  resource_wizard_preview_services_title: "Which bookings use \"@{name}\"?",
  resource_wizard_preview_services_caption: "Based on the services you select.",
  resource_wizard_preview_services_empty: "Select services on the left.",
  resource_wizard_preview_service_one_place: "Takes one place.",
  resource_wizard_preview_service_group_one_place:
    "Takes one place for the whole group.",
  resource_wizard_preview_service_run_by: "Run by: @{names}",
  resource_wizard_insight_people_one_service:
    "This service is run by @{count} person|This service is run by @{count} people",
  resource_wizard_insight_people_services:
    "These services are run by @{count} person|These services are run by @{count} people",
  resource_wizard_insight_pool_capacity:
    "and the pool \"@{name}\" has @{count} position.|and the pool \"@{name}\" has @{count} positions.",
  resource_wizard_insight_resource_capacity:
    "and the resource \"@{name}\" has @{count} available.",
  resource_wizard_insight_short:
    "At the same time, the calendar won't let customers book @{count} of them.|At the same time, the calendar won't let customers book @{count} of them.",
  resource_wizard_insight_enough_all:
    "There's enough room even when everyone works at the same time.",
  resource_wizard_insight_enough: "There's enough room.",
  resource_wizard_preview_group_caption:
    "Up to @{max} people per session. \"@{name}\": @{units}.",
  resource_wizard_preview_group_slot_box: "@{service}, @{max} people booked",
  resource_wizard_preview_group_slot_takes:
    "takes 1 of @{capacity} places in \"@{name}\"",
  resource_wizard_preview_group_left_positions:
    "@{count} position stays free for other bookings at that time.|@{count} positions stay free for other bookings at that time.",
  resource_wizard_preview_group_left_units:
    "@{count} unit stays free for other bookings at that time.|@{count} units stay free for other bookings at that time.",
  resource_wizard_preview_group_none_left:
    "No other booking fits at that time.",
  resource_wizard_preview_group_participants_fit:
    "At most @{count} person can join|At most @{count} people can join",
  resource_wizard_preview_group_participants_left:
    "Each participant takes their own place. @{count} place stays free for other bookings at that time.|Each participant takes their own place. @{count} places stay free for other bookings at that time.",
  resource_wizard_preview_group_too_small:
    "The service takes up to @{max} people, but each needs their own place and you have @{capacity}. If the group shares one place, pick the second option.",
  resource_wizard_preview_day_title: "An example day",
  resource_wizard_preview_day_caption:
    "Everyone has a booking at 10:00, and @{first} at 11:00 too.",
  resource_wizard_preview_bookings_row: "Bookings",
  resource_wizard_preview_legend_gets: "has a spot",
  resource_wizard_preview_legend_waits: "waits for staff",
  resource_wizard_preview_legend_missed: "no spot, customers won’t see this hour",
  resource_wizard_preview_day_needs_services:
    "Select services in the \"Services\" step and we'll show an example day with your team.",
  resource_wizard_preview_taken: "Taken",
  resource_wizard_preview_customers_see: "Customers see",
  resource_wizard_preview_free: "free",
  resource_wizard_preview_gone: "hidden",
  resource_wizard_preview_log_takes:
    "@{employee}, @{hour}, @{service}: takes one unit of \"@{resource}\".",
  resource_wizard_preview_log_gets:
    "@{employee}, @{hour}, @{service}: gets \"@{unit}\".",
  resource_wizard_preview_log_waits:
    "@{employee}, @{hour}, @{service}: nothing the system can give on its own. The booking is saved and waits for you to assign a position. Until then it takes a place, e.g. \"@{unit}\".",
  resource_wizard_preview_log_full:
    "@{employee}, @{hour}, @{service}: no free place, so customers won't see this time with this person. You can still save such a booking in the panel.",
  resource_wizard_preview_log_no_match:
    "@{employee}, @{hour}, @{service}: no free position is meant for this booking, so customers won't see this time with this person.",
  resource_wizard_preview_manual_note:
    "A booking waiting for a manual assignment still takes a place. So \"@{name}\" takes at most @{count} booking at the same time, even before you assign anything.|A booking waiting for a manual assignment still takes a place. So \"@{name}\" takes at most @{count} bookings at the same time, even before you assign anything.",
  resource_wizard_preview_order_note:
    "When several free positions fit, the system first gives the one meant for the fewest bookings and keeps \"All bookings\" positions for last. That way customers see as many free times as possible.",
  resource_wizard_example_no_fit:
    "No booking fits this choice right now, so the system won't give \"@{name}\" to anyone.",
  booking_awaiting_resource: "Waiting for a resource",
  booking_not_awaiting_resource: "Not waiting for a resource",
  booking_awaiting_resource_info:
    "The booking's service uses a resource pool, but no position is assigned yet. Assign one when you edit the booking.",
  availability_schedule_resource_blocked:
    "@{employee}: customers won't see any free slots in these hours. The selected positions of the pool \"@{pool}\" are meant for other bookings.",
  availability_schedule_resource_manual:
    "@{employee}: customers won't see any free slots in these hours, because you assign the selected positions of the pool \"@{pool}\" yourself. Set them to \"All bookings\" or \"Only selected bookings\", or pick other positions.",
  resource_wizard_schedule_blocked:
    "The schedule \"@{schedule}\" names only positions of this pool for @{employee}. Once you save, customers won't see free slots with this person in those hours.",
  recurring_series_length_locked:
    "An existing series keeps its number of repeats. To shorten it, delete \"This event and all following ones\" from the first date you don't need. To extend it, add a new series.",
  recurring_series_day_move_not_possible:
    "This series can't move to the day you picked: its repeat pattern (for example \"the last weekday of the month\") wouldn't hold after the move. Delete \"This event and all following ones\" and add a new series from the day you want.",
  recurring_series_changed_meanwhile:
    "This series changed in the meantime. Refresh the calendar and try again.",
  class_capacity_exceeded:
    "This class takes @{max} people. After this change it would have @{total}.",
  remove_tag_title:
    "Remove label",
  remove_tag_named:
    "The label \"@{name}\" will disappear from every booking and customer that has it.",
  remove_group_title:
    "Remove group",
  remove_group_named:
    "Customers in the group \"@{name}\" will no longer belong to it. The customers stay.",
  remove_resource_title:
    "Remove resource",
  remove_resource_named:
    "The resource \"@{name}\" will disappear from its services and from every booking that holds it. The bookings stay.",
  remove_pool_title:
    "Remove pool",
  remove_pool_named:
    "The pool \"@{name}\" will disappear from its services together with its positions, and the positions will disappear from the bookings they were assigned to. The bookings stay.",
  remove_position_title:
    "Remove position",
  remove_position_named:
    "The position \"@{name}\" will disappear from every booking that holds it. The bookings stay.",
  resource_wizard_remove_positions_title:
    "Remove positions?",
  resource_wizard_remove_positions_warning:
    "You will remove: @{names}. Bookings from today on that hold them: @{count}. They lose these positions but stay.",
  resource_wizard_remove_positions_button:
    "Remove positions",
  resource_wizard_remove_positions_warning_no_count:
    "You will remove: @{names}. Bookings that hold them lose these positions but stay.",
  service_description_title: "Service description",
  service_description_hint: "Clients see it when they choose the service.",
  service_description_placeholder: "Describe the service in a few words",
  service_advanced_texts_title: "Texts for clients",
  service_advanced_texts_hint:
    "Extra content during booking and in booking emails.",
  upselling_description_placeholder:
    "For example, a tip about an add-on product",
  additional_information_after_booking_placeholder:
    "For example, how to get to you or what to bring",
  additional_information_after_booking_variable_info:
    "If your notifications have custom content, add the [ADDITIONAL_INFORMATION_AFTER_BOOKING] variable to them. Without it, this information won't show.",
  service_advanced_availability_title: "Availability and resources",
  service_advanced_availability_hint:
    "Extra limits on booking times and the resources this service needs.",
  service_advanced_resources_title: "Resources",
  service_advanced_resources_hint: "Rooms and equipment this service needs.",
  recurrence_too_long:
    "This series has too many occurrences. Pick an earlier end date or fewer occurrences.",
  overlap_check_occurrences_truncated:
    "We checked only the first 1000 occurrences of this series.",
  series_saved_occurrences_truncated:
    "Saved. We checked for conflicts only in the first 1000 occurrences of this series.",
  location_skype_retired_info:
    "Skype stopped working in May 2025. Choose Microsoft Teams or another location.",
  cookie_settings: "Cookie settings",
};
